import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { AlertComponent } from '../../alert/alert.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AuthAlertComponent } from '../../auth-alert/auth-alert.component';
import { FinanceServicesService } from 'src/app/services/finance-services.service';
import { AddCompanyDetailsService } from 'src/app/services/add-company-details.service';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from 'src/app/services/loader.service';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-update-finance-details',
  templateUrl: './update-finance-details.component.html',
  styleUrls: ['./update-finance-details.component.css']
})
export class UpdateFinanceDetailsComponent implements OnInit {

  public environmentSettings: any;

  nameModel: any;
  Amount: any;

  // @Input() totalPaid: any;
  @Input() paidupEquity: any;
  @Input() paidupPreference: any;

  surplusOthers: any;
  debitBalance: any;
  surplus: any;
  reneralReserve: any;
  subscribedEquity: any;
  issuedEquity: any;
  authorizedEquity: any;
  financialYearvalue: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  companyMasterForm: FormGroup;
  financialDataForm: FormGroup;
  companies: any[];
  classesOfCompany: any[];
  typesOfCompany: any[];
  registrationIDTypes: any[];
  typesOfIndustry: any[];
  financialYears: any[];
  companyId: string;
  CompanyList: any;
  financialDataDetails: any;
  showSelected: boolean;
  // classOfCompany :any;
  equityListing: any;
  equityListingSMESegment: any;
  onlyDebtListing: any;
  debtListing: any;
  globalIncorporationYear: any;
  financialYearFromModel: any;
  financialYearToModel: any;
  dateOfIncorporationModel: any;
  error: any = { isError: false, errorMessage: '' };
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  companyAutoCompleteList: any;
  companyNameModel: any;
  peersList: any;
  selectedPeers: any;
  industryCode: any;
  housingCode: any;
  invalidPeers: any;
  errors: any = { isError: false, errorMessage: '' };
  IssuedEquityError: any = { isError: false, errorMessage: '' };
  SubscribedShareCapital: any = { isError: false, errorMessage: '' };
  PaidupEquityShareCapital: any = { isError: false, errorMessage: '' };
  IssuedPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  SubscribedPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  PaidupPreferenceShareCapital: any = { isError: false, errorMessage: '' };
  chosenPeers: any;
  number = 0.5;
  totals: number;
  value2: number;
  paidup: any;
  totalPaidTab1: any;
  totalFreeReserveAmount: any;
  OtherthanfreeReservesAmount: any;
  TotalReservesandSurplusAmount: any;
  LoansfromBank: any;
  DeferredPayment: any
  Depositsaccepted: any;
  LoansandAdvances: any;
  LongTermMaturities: any;
  BondsDebentures: any;
  TotalBorrowingAggregate: any;
  currentURL: any;
  id: any;
  btnValue: any;
  newValue: any;
  checkValidationInput: any;
  companyID: any;
  companyName: any;
  projectKeys: any;
  newArray = [];
  dateOfHistroyModel: any;
  fincacialHistoryData: any[];
  effectiveDate: any;
  remarks: any;
  issuedEquityShareCapitalArray = [];
  NewAuthorizedEquityShareCapitals: any;
  OldAuthorizedEquityShareCapital: any;
  newIssuedEquityShareCapital: any;
  oldIssuedEquityShareCapital: any;
  financialDataList: any;
  newfinanceyear: any;

  // The trigger needed to re-render the table
  authorizedEquityShareCapitalDtOption: DataTables.Settings = {};
  authorizedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  issuedEquityShareCapitalDtOption: DataTables.Settings = {};
  issuedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  subscribedEquityShareCapitalDtOption: DataTables.Settings = {};
  subscribedEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  paidupEquityShareCapitalDtOption: DataTables.Settings = {};
  paidupEquityShareCapitalDtTrigger: Subject<any> = new Subject();
  authorizedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  authorizedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  issuedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  issuedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  subscribedPreferenceShareCapitalDtOption: DataTables.Settings = {};
  subscribedPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  paidupPreferenceShareCapitalDtOption: DataTables.Settings = {};
  paidupPreferenceShareCapitalDtTrigger: Subject<any> = new Subject();
  totalPaidUpShareCapitalDtOption: DataTables.Settings = {};
  totalPaidUpShareCapitalDtTrigger: Subject<any> = new Subject();
  generalReserveDtOption: DataTables.Settings = {};
  generalReserveDtTrigger: Subject<any> = new Subject();
  surplusProfitAndLossDtOption: DataTables.Settings = {};
  surplusProfitAndLossDtTrigger: Subject<any> = new Subject();
  debitBalanceofStatementofProfitandLossDtOption: DataTables.Settings = {};
  debitBalanceofStatementofProfitandLossDtTrigger: Subject<any> = new Subject();
  surplusOthersDataTableDtOption: DataTables.Settings = {};
  surplusOthersDataTableDtTrigger: Subject<any> = new Subject();
  totalFreeReservesDtOption: DataTables.Settings = {};
  totalFreeReservesDtTrigger: Subject<any> = new Subject();
  capitalReserveProceedsReceivedInCashDtOption: DataTables.Settings = {};
  capitalReserveProceedsNotReceivedInCashDtTrigger: Subject<any> = new Subject();
  capitalReserveProceedsNotReceivedInCashDtOption: DataTables.Settings = {};
  capitalReserveProceedsReceivedInCashDtTrigger: Subject<any> = new Subject();
  capitalRedemptionReserveDtOption: DataTables.Settings = {};
  capitalRedemptionReserveDtTrigger: Subject<any> = new Subject();
  securityPremiumReserveDtOption: DataTables.Settings = {};
  securityPremiumReserveDtTrigger: Subject<any> = new Subject();
  othersDtOption: DataTables.Settings = {};
  othersDtTrigger: Subject<any> = new Subject();
  totalReservesOtherThanFreeReservesDtOption: DataTables.Settings = {};
  totalReservesOtherThanFreeReservesDtTrigger: Subject<any> = new Subject();
  totalReservesAndSurplusDtOption: DataTables.Settings = {};
  totalReservesAndSurplusDtTrigger: Subject<any> = new Subject();
  shareCapitalAndFreeReservesDtOption: DataTables.Settings = {};
  shareCapitalAndFreeReservesDtTrigger: Subject<any> = new Subject();
  netWorthDtOption: DataTables.Settings = {};
  netWorthDtTrigger: Subject<any> = new Subject();
  turnoverDtOption: DataTables.Settings = {};
  turnoverDtTrigger: Subject<any> = new Subject();
  netProfitForManagerialRemunerationDtOption: DataTables.Settings = {};
  netProfitForManagerialRemunerationDtTrigger: Subject<any> = new Subject();
  netProfitForCSRApplicabilityDtOption: DataTables.Settings = {};
  netProfitForCSRApplicabilityDtTrigger: Subject<any> = new Subject();
  loanGivenDtOption: DataTables.Settings = {};
  loanGivenDtTrigger: Subject<any> = new Subject();
  guaranteeOrSecurityGivenDtOption: DataTables.Settings = {};
  guaranteeOrSecurityGivenDtTrigger: Subject<any> = new Subject();
  acquisitionOfSecuritiesDtOption: DataTables.Settings = {};
  acquisitionOfSecuritiesDtTrigger: Subject<any> = new Subject();
  loansOthersDtOption: DataTables.Settings = {};
  loansOthersDtTrigger: Subject<any> = new Subject();
  totalLoansAndInvestmentsLimitsDtOption: DataTables.Settings = {};
  totalLoansAndInvestmentsLimitsDtTrigger: Subject<any> = new Subject();
  loansfromBankandFinancialInstitutionsDtOption: DataTables.Settings = {};
  loansfromBankandFinancialInstitutionsDtTrigger: Subject<any> = new Subject();
  deferredPaymentLiabilitiesDtOption: DataTables.Settings = {};
  deferredPaymentLiabilitiesDtTrigger: Subject<any> = new Subject();
  depositsLongTermAndShortTermDtOption: DataTables.Settings = {};
  depositsLongTermAndShortTermDtTrigger: Subject<any> = new Subject();
  loansandAdvancesfromRelatedPartiesDtOption: DataTables.Settings = {};
  loansandAdvancesfromRelatedPartiesDtTrigger: Subject<any> = new Subject();
  longTermMaturitiesofLeaseObligationsDtOption: DataTables.Settings = {};
  longTermMaturitiesofLeaseObligationsDtTrigger: Subject<any> = new Subject();
  bondsAndDebenturesDtOption: DataTables.Settings = {};
  bondsAndDebenturesDtTrigger: Subject<any> = new Subject();
  othersBorrowingDtOption: DataTables.Settings = {};
  othersBorrowingDtTrigger: Subject<any> = new Subject();
  totalBorrowingDtOption: DataTables.Settings = {};
  totalBorrowingDtTrigger: Subject<any> = new Subject();
  shortTermLoansDtOption: DataTables.Settings = {};
  shortTermLoansDtTrigger: Subject<any> = new Subject();
  cashCreditArrangementsDtOption: DataTables.Settings = {};
  cashCreditArrangementsDtTrigger: Subject<any> = new Subject();
  discountingofBiillsDtOption: DataTables.Settings = {};
  discountingofBiillsDtTrigger: Subject<any> = new Subject();
  otherShortTermLoansofSeasonalCharacterDtOption: DataTables.Settings = {};
  otherShortTermLoansofSeasonalCharacterDtTrigger: Subject<any> = new Subject();
  outstandingLoansLaonDtOption: DataTables.Settings = {};
  outstandingLoansLaonDtTrigger: Subject<any> = new Subject();
  totalTemporaryLoansDtOption: DataTables.Settings = {};
  totalTemporaryLoansDtTrigger: Subject<any> = new Subject();
  borrowingLimitsDtOption: DataTables.Settings = {};
  borrowingLimitsDtTrigger: Subject<any> = new Subject();
  disabledOnclick: boolean;

  financialDataDisplay = {
    shareCapital: {
      authorizedEquityShareCapital: "",
      authorizedEquityShareCapitalHistory: [],
      authorizedEquityShareCapitalEffectiveDate: "",
      authorizedEquityShareCapitalRemarks: "",

      issuedEquityShareCapital: "",
      issuedEquityShareCapitalHistory: [],
      issuedEquityShareCapitalEffectiveDate: "",
      issuedEquityShareCapitalRemarks: "",

      subscribedEquityShareCapital: "",
      subscribedEquityShareCapitalHistory: [],
      subscribedEquityShareCapitalEffectiveDate: "",
      subscribedEquityShareCapitalRemarks: "",

      paidupEquityShareCapital: "",
      paidupEquityShareCapitalHistory: [],
      paidupEquityShareCapitalEffectiveDate: "",
      paidupEquityShareCapitalRemarks: "",

      authorizedPreferenceShareCapital: "",
      authorizedPreferenceShareCapitalHistory: [],
      authorizedPreferenceShareCapitalEffectiveDate: "",
      authorizedPreferenceShareCapitalRemarks: "",

      issuedPreferenceShareCapital: "",
      issuedPreferenceShareCapitalHistory: [],
      issuedPreferenceShareCapitalEffectiveDate: "",
      issuedPreferenceShareCapitalRemarks: "",

      subscribedPreferenceShareCapital: "",
      subscribedPreferenceShareCapitalHistory: [],
      subscribedPreferenceShareCapitalEffectiveDate: "",
      subscribedPreferenceShareCapitalRemarks: "",

      paidupPreferenceShareCapital: "",
      paidupPreferenceShareCapitalHistory: [],
      paidupPreferenceShareCapitalEffectiveDate: "",
      paidupPreferenceShareCapitalRemarks: "",

      totalPaidUpShareCapital: "",
      totalPaidUpShareCapitalHistory: []
    },
    reservesAndSurplus: {
      generalReserve: "",
      generalReserveHistory: [],
      generalReserveEffectiveDate: "",
      generalReserveRemarks: "",

      surplusProfitAndLoss: "",
      surplusProfitAndLossHistory: [],
      surplusProfitAndLossEffectiveDate: "",
      surplusProfitAndLossRemarks: "",

      debitBalanceofStatementofProfitandLoss: "",
      debitBalanceofStatementofProfitandLossHistory: [],
      debitBalanceofStatementofProfitandLossEffectiveDate: "",
      debitBalanceofStatementofProfitandLossRemarks: "",

      surplusOthers: "",
      surplusOthersHistory: [],
      surplusOthersEffectiveDate: "",
      surplusOthersRemarks: "",

      totalFreeReserve: "",
      totalFreeReserveHistory: [],
      totalFreeReserveEffectiveDate: "",
      totalFreeReserveRemarks: "",

      othersCapitalReserve: "",
      othersCapitalReserveHistory: [],
      othersCapitalReserveEffectiveDate: "",
      othersCapitalReserveRemarks: "",

      capitalReserveProceedsReceivedInCash: "",
      capitalReserveProceedsReceivedInCashHistory: [],
      capitalReserveProceedsReceivedInCashEffectiveDate: "",
      capitalReserveProceedsReceivedInCashRemarks: "",

      capitalReserveProceedsNotReceivedInCash: "",
      capitalReserveProceedsNotReceivedInCashHistory: [],
      capitalReserveProceedsNotReceivedInCashEffectiveDate: "",
      capitalReserveProceedsNotReceivedInCashRemarks: "",

      capitalRedemptionReserve: "",
      capitalRedemptionReserveHistory: [],
      capitalRedemptionReserveEffectiveDate: "",
      capitalRedemptionReserveRemarks: "",

      securityPremiumReserve: "",
      securityPremiumReserveHistory: [],
      securityPremiumReserveEffectiveDate: "",
      securityPremiumReserveRemarks: "",

      totalReservesOtherThanFreeReserves: "",
      totalReservesOtherThanFreeReservesHistory: [],

      totalReservesAndSurplus: "",
      totalReservesAndSurplusHistory: [],

      shareCapitalAndFreeReserves: "",
      shareCapitalAndFreeReservesHistory: [],

      netWorth: "",
      netWorthHistory: [],

      turnover: "",
      turnoverHistory: [],
      turnoverEffectiveDate: "",
      turnoverRemarks: "",

      netProfitForManagerialRemuneration: "",
      netProfitForManagerialRemunerationHistory: [],
      netProfitForManagerialRemunerationEffectiveDate: "",
      netProfitForManagerialRemunerationRemarks: "",

      netProfitForCSRApplicability: "",
      netProfitForCSRApplicabilityHistory: [],
      netProfitForCSRApplicabilityEffectiveDate: "",
      netProfitForCSRApplicabilityRemarks: ""
    },
    loanAndInvestMent: {
      loanGiven: "",
      loanGivenHistory: [],
      loanGivenEffectiveDate: "",
      loanGivenRemarks: "",

      guaranteeOrSecurityGiven: "",
      guaranteeOrSecurityGivenHistory: [],
      guaranteeOrSecurityGivenEffectiveDate: "",
      guaranteeOrSecurityGivenRemarks: "",

      acquisitionOfSecurities: "",
      acquisitionOfSecuritiesHistory: [],
      acquisitionOfSecuritiesEffectiveDate: "",
      acquisitionOfSecuritiesRemarks: "",

      loansOthers: "",
      loansOthersHistory: [],
      loansOthersEffectiveDate: "",
      loansOthersRemarks: "",

      totalLoansAndInvestmentsLimits: "",
      totalLoansAndInvestmentsLimitsHistory: [],
    },
    borrowing: {
      loansfromBankandFinancialInstitutions: "",
      loansfromBankandFinancialInstitutionsHistory: [],
      loansfromBankandFinancialInstitutionsEffectiveDate: "",
      loansfromBankandFinancialInstitutionsRemarks: "",

      deferredPaymentLiabilities: "",
      deferredPaymentLiabilitiesHistory: [],
      deferredPaymentLiabilitiesEffectiveDate: "",
      deferredPaymentLiabilitiesRemarks: "",

      depositsLongTermAndShortTerm: "",
      depositsLongTermAndShortTermHistory: [],
      depositsLongTermAndShortTermEffectiveDate: "",
      depositsLongTermAndShortTermRemarks: "",

      loansandAdvancesfromRelatedParties: "",
      loansandAdvancesfromRelatedPartiesHistory: [],
      loansandAdvancesfromRelatedPartiesEffectiveDate: "",
      loansandAdvancesfromRelatedPartiesRemarks: "",

      longTermMaturitiesofLeaseObligations: "",
      longTermMaturitiesofLeaseObligationsHistory: [],
      longTermMaturitiesofLeaseObligationsEffectiveDate: "",
      longTermMaturitiesofLeaseObligationsRemarks: "",

      bondsAndDebentures: "",
      bondsAndDebenturesHistory: [],
      bondsAndDebenturesEffectiveDate: "",
      bondsAndDebenturesRemarks: "",

      othersBorrowing: "",
      othersBorrowingHistory: [],
      othersBorrowingEffectiveDate: "",
      othersBorrowingRemarks: "",

      totalBorrowing: "",
      totalBorrowingHistory: []
    },
    temporaryLoan: {
      shortTermLoans: "",
      shortTermLoansHistory: [],
      shortTermLoansEffectiveDate: "",
      shortTermLoansRemarks: "",

      cashCreditArrangements: "",
      cashCreditArrangementsHistory: [],
      cashCreditArrangementsEffectiveDate: "",
      cashCreditArrangementsRemarks: "",

      discountingofBiills: "",
      discountingofBiillsHistory: [],
      discountingofBiillsEffectiveDate: "",
      discountingofBiillsRemarks: "",

      otherShortTermLoansofSeasonalCharacter: "",
      otherShortTermLoansofSeasonalCharacterHistory: [],
      otherShortTermLoansofSeasonalCharacterEffectiveDate: "",
      otherShortTermLoansofSeasonalCharacterRemarks: "",

      outstandingLoans: "",
      outstandingLoansLaonHistory: [],
      outstandingLoansEffectiveDate: "",
      outstandingLoansRemarks: "",

      totalTemporaryLoans: "",
      totalTemporaryLoansHistory: [],

      borrowingLimits: "",
      borrowingLimitsHistory: []
    }
  };

  adjustEditHistoryBoxWidth: any;

  constructor(private alert: AlertComponent,
    private financeServiceRelatedCompany: FinanceServicesService,
    private companyMasterService: AddCompanyDetailsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonFunction: CommonFunction,
    private meetingService: MeetingMasterService,
    private authAlert: AuthAlertComponent,private route: ActivatedRoute, private loaderService: LoaderService) {

  }

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.loaderService.disable();
    this.environmentSettings = environment;

    this.initializeJqueryEvent();
    this.adjustEditHistoryBoxWidth = 2;
    this.setCompnayDetails();
    this.dataTableRefreshFunction();
    this.showSelected = false;
    this.currentURL = window.location.href;
    this.checkValidationInput = false;
    this.getFinacialData();
    // if (this.currentURL.indexOf("add") !== -1) {
    //   this.addNewFinancialDetails();
    //   this.btnValue = 'Save';
    // } else {
    //   this.getFinacialData();
    //   this.btnValue = 'Update';
    // }
    this.financialDataForm = new FormGroup({
      FinancialYear: new FormControl('', [Validators.required]),
      subscribedShareCapital: new FormControl('', []),
      SurplusOthers: new FormControl('', []),
      CapitalReserveCash: new FormControl('', []),
      capitalReserveNotCash: new FormControl('', []),

      managerialRemunerationNetProfit: new FormControl('', []),
      cSRApplicabilityNetProfit: new FormControl('', []),
      securityofLoan: new FormControl('', []),
      acquisitionCost: new FormControl('', []),
      typeOfIndustry: new FormControl('', []),
      deposits: new FormControl('', []),
      discountingofBills: new FormControl('', []),
      bondsDebentures: new FormControl('', []),
      borrowOthers: new FormControl('', []),
      totalFreeReserve: new FormControl('', []),
      // totalPaidUpShareCapital: new FormControl('', []),
      otherthanfreeReserves: new FormControl('', []),

      others: new FormControl('', []),
      totalLoansandInvestments: new FormControl('', []),
      OthersCapitalReserve: new FormControl('', []),

      //control of AuthorizedEquityShareCapital     
      authorizedEquityShareCapital: new FormControl('', []),
      dateOfUpdateAuthorizedEquityShareCapital: new FormControl('', []),
      remarksAuthorizedEquityShareCapital: new FormControl('', []),

      //control of EquityShareCapital
      issuedEquityShareCapital: new FormControl('', []),
      dateOfUpdateOfIssuedEquityShareCapital: new FormControl('', []),
      remarksOfIssuedEquityShareCapital: new FormControl('', []),

      //control of SubscribedShareCapital
      subscribedEquityShareCapital: new FormControl('', []),
      dateOfUpdateOfsubscribedShareCapital: new FormControl('', []),
      remarksOfsubscribedShareCapital: new FormControl('', []),

      //control of PaidupEquityShareCapital
      paidupEquityShareCapital: new FormControl('', []),
      dateOfUpdateOfPaidupEquityShareCapital: new FormControl('', []),
      remarksOfPaidupEquityShareCapital: new FormControl('', []),

      //control of PaidupEquityShareCapital
      authorizedPreferenceShareCapital: new FormControl('', []),
      dateOfUpdateOfAuthorizedPreferenceShareCapital: new FormControl('', []),
      remarksOfAuthorizedPreferenceShareCapital: new FormControl('', []),

      //control of IssuedPreferenceShareCapital
      issuedPreferenceShareCapital: new FormControl('', []),
      dateOfUpdateOfIssuedPreferenceShareCapital: new FormControl('', []),
      remarksOfIssuedPreferenceShareCapital: new FormControl('', []),

      //control of SubscribedPreferenceShareCapital
      subscribedPreferenceShareCapital: new FormControl('', []),
      dateOfUpdateOfSubscribedPreferenceShareCapital: new FormControl('', []),
      remarksOfSubscribedPreferenceShareCapital: new FormControl('', []),

      //control of PaidupPreferenceShareCapital
      paidupPreferenceShareCapital: new FormControl('', []),
      dateOfUpdateOfPaidupPreferenceShareCapital: new FormControl('', []),
      remarksOfPaidupPreferenceShareCapital: new FormControl('', []),

      //control of GeneralReserve
      generalReserve: new FormControl('', []),
      dateOfUpdateOfGeneralReserve: new FormControl('', []),
      remarksOfGeneralReserve: new FormControl('', []),

      //control of Surplus
      surplusProfitAndLoss: new FormControl('', []),
      dateOfUpdateOfSurplus: new FormControl('', []),
      remarksOfSurplus: new FormControl('', []),

      //control of DebitBalanceofStatementofProfitandLoss
      debitBalanceofStatementofProfitandLoss: new FormControl('', []),
      dateOfUpdateOfDebitBalanceofStatementofProfitandLoss: new FormControl('', []),
      remarksOfDebitBalanceofStatementofProfitandLoss: new FormControl('', []),

      //control of Surplus
      surplusOthers: new FormControl('', []),
      dateOfUpdateOfSurplusOthers: new FormControl('', []),
      remarksOfSurplusOthers: new FormControl('', []),

      //control of CapitalReserveInCash
      capitalReserveProceedsReceivedInCash: new FormControl('', []),
      dateOfUpdateOfCapitalReserveInCash: new FormControl('', []),
      remarksOfCapitalReserveInCash: new FormControl('', []),

      //control of CapitalReserveNotCash
      capitalReserveProceedsNotReceivedInCash: new FormControl('', []),
      dateOfUpdateOfCapitalReserveNotCash: new FormControl('', []),
      remarksOfCapitalReserveNotCash: new FormControl('', []),

      //control of CapitalRedemptionReserve
      capitalRedemptionReserve: new FormControl('', []),
      dateOfUpdateOfCapitalRedemptionReserve: new FormControl('', []),
      remarksOfCapitalRedemptionReserve: new FormControl('', []),

      //control of SecurityPremiumReserve
      securityPremiumReserve: new FormControl('', []),
      dateOfUpdateOfSecurityPremiumReserve: new FormControl('', []),
      remarksOfSecurityPremiumReserve: new FormControl('', []),

      //control of OthersCapitalReserve
      othersCapitalReserve: new FormControl('', []),
      dateOfUpdateOfOthersCapitalReserve: new FormControl('', []),
      remarksOfOthersCapitalReserve: new FormControl('', []),

      //control of Share Capital And Free Reserves
      shareCapitalAndFreeReserves: new FormControl('', []),
      dateOfUpdateOfShareCapitalAndFreeReserves: new FormControl('', []),
      remarksOfShareCapitalAndFreeReserves: new FormControl('', []),

      //control of Turnover
      turnover: new FormControl('', []),
      dateOfUpdateOfTurnover: new FormControl('', []),
      remarksOfTurnover: new FormControl('', []),

      //control of Net Profit
      netProfitForManagerialRemuneration: new FormControl('', []),
      dateOfUpdateOfManagerialRemunerationNetProfit: new FormControl('', []),
      remarksOfManagerialRemunerationNetProfit: new FormControl('', []),

      //control of CSR Applicability NetProfit
      netProfitForCSRApplicability: new FormControl('', []),
      dateOfUpdateOfCSRApplicabilityNetProfit: new FormControl('', []),
      remarksOfCSRApplicabilityNetProfit: new FormControl('', []),

      //control of Loan Given
      loanGiven: new FormControl('', []),
      dateOfUpdateOfLoanGiven: new FormControl('', []),
      remarksOfLoanGiven: new FormControl('', []),

      //control of Loan Given
      totalLoansAndInvestmentsLimits: new FormControl('', []),
      dateOfUpdateOfTotalLoansAndInvestmentsLimits: new FormControl('', []),
      remarksOfTotalLoansAndInvestmentsLimits: new FormControl('', []),

      //control of Total Borrowing    
      totalBorrowingAmountOfBorriwngTab: new FormControl('', []),
      dateOfUpdateOfTalBorrowingAmountOfBorriwngTab: new FormControl('', []),
      remarksOfTalBorrowingAmountOfBorriwngTab: new FormControl('', []),

      //control of Guarantee Of Security Loan 
      guaranteeOrSecurityGiven: new FormControl('', []),
      dateOfUpdateOfSecurityofLoan: new FormControl('', []),
      remarksOfSecurityofLoan: new FormControl('', []),

      //control of Aquisition Cost
      acquisitionOfSecurities: new FormControl('', []),
      dateOfUpdateOfAcquisitionCost: new FormControl('', []),
      remarksOfAcquisitionCost: new FormControl('', []),

      //control of Security of Loan
      loansOthers: new FormControl('', []),
      dateOfUpdateOfLoansOthers: new FormControl('', []),
      remarksOfLoansOthers: new FormControl('', []),

      //control of Loans from Bank Financial Institutions
      loansfromBankandFinancialInstitutions: new FormControl('', []),
      dateOfUpdateOfLoansfromBankandFinancialInstitutions: new FormControl('', []),
      remarksOfLoansfromBankandFinancialInstitutions: new FormControl('', []),

      //control of Deferred Payment Liabilities
      deferredPaymentLiabilities: new FormControl('', []),
      dateOfUpdateOfDeferredPaymentLiabilities: new FormControl('', []),
      remarksOfDeferredPaymentLiabilities: new FormControl('', []),

      //control of Deposits
      depositsLongTermAndShortTerm: new FormControl('', []),
      dateOfUpdateOfDeposits: new FormControl('', []),
      remarksOfDeposits: new FormControl('', []),

      //control of Loans and Advances from Related Partie
      loansandAdvancesfromRelatedParties: new FormControl('', []),
      dateOfUpdateOfLoansandAdvancesfromRelatedParties: new FormControl('', []),
      remarksOfLoansandAdvancesfromRelatedParties: new FormControl('', []),

      //control of Long Term Maturities of Lease Obligations
      longTermMaturitiesofLeaseObligations: new FormControl('', []),
      dateOfUpdateOfLongTermMaturitiesofLeaseObligations: new FormControl('', []),
      remarksOfLongTermMaturitiesofLeaseObligations: new FormControl('', []),

      //control of Bonds Debentures
      bondsAndDebentures: new FormControl('', []),
      dateOfUpdateOfBondsDebentures: new FormControl('', []),
      remarksOfBondsDebentures: new FormControl('', []),

      //control of Others Borrowing
      othersBorrowing: new FormControl('', []),
      dateOfUpdateOfOthersBorrowing: new FormControl('', []),
      remarksOfOthersBorrowing: new FormControl('', []),

      //control of Short Term Loans
      shortTermLoans: new FormControl('', []),
      dateOfUpdateOfShortTermLoans: new FormControl('', []),
      remarksOfShortTermLoans: new FormControl('', []),

      //control of Cash Credit Arrangements
      cashCreditArrangements: new FormControl('', []),
      dateOfUpdateOfCashCreditArrangements: new FormControl('', []),
      remarksOfCashCreditArrangements: new FormControl('', []),


      //control of Discounting of Bills
      discountingofBiills: new FormControl('', []),
      dateOfUpdateOfDiscountingofBills: new FormControl(null, []),
      remarksOfDiscountingofBills: new FormControl('', []),

      //control of Other Short Term Loans of Seasonal Character
      otherShortTermLoansofSeasonalCharacter: new FormControl('', []),
      dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter: new FormControl(null, []),
      remarksOfOtherShortTermLoansofSeasonalCharacter: new FormControl('', []),

      //control of Outstanding Loans
      outstandingLoans: new FormControl('', []),
      dateOfUpdateOfOutstandingLoans: new FormControl(null, []),
      remarksOfOutstandingLoans: new FormControl('', []),

      //control of Total Temporary Loans
      totalTemporaryLoans: new FormControl('', []),
      dateOfUpdateOfTotalTemporaryLoans: new FormControl('', []),
      remarksOfTotalTemporaryLoans: new FormControl('', []),

      //control of Total Temporary Loans
      netWorth: new FormControl('', []),
      dateOfUpdateOfNetWorth: new FormControl('', []),
      remarksOfNetWorth: new FormControl('', []),

      //control of Total Free Reserves
      totalFreeReserves: new FormControl('', []),
      dateOfUpdateOfTotalFreeReserves: new FormControl('', []),
      remarksOfTotalFreeReserves: new FormControl('', []),

      //control of Total Reserves Other Than Free Reserves
      totalReservesOtherThanFreeReserves: new FormControl('', []),
      dateOfUpdateOfTotalReservesOtherThanFreeReserves: new FormControl('', []),
      remarksOfTotalReservesOtherThanFreeReserves: new FormControl('', []),

      //control of Total Paid Up Share Capital
      totalPaidUpShareCapital: new FormControl('', []),
      dateOfUpdateOfTotalPaidUpShareCapital: new FormControl('', []),
      remarksOfTotalPaidUpShareCapital: new FormControl('', []),

      //control of Total Reserves and Surplus     
      totalReservesAndSurplus: new FormControl('', []),
      dateOfUpdateOftotalReservesAndSurplus: new FormControl('', []),
      remarksOftotalReservesAndSurplus: new FormControl('', []),

      //control of Borrowing (Limits u/s 180)     
      borrowing: new FormControl('', []),
      dateOfUpdateOfBorrowing: new FormControl('', []),
      remarksOfBorrowing: new FormControl('', []),

      //control of Total Borrowing    
      totalBorrowing: new FormControl('', []),
      dateOfUpdateOfTotalBorrowing: new FormControl('', []),
      remarksOfTotalBorrowing: new FormControl('', []),
    });
console.log('hh')
    this.financialDataForm.controls.FinancialYear.setValue('');
console.log('hh',this.financialDataForm)

  }

  initializeJqueryEvent() {

    $('.history-modal-popup').on('shown.bs.modal', function (e) {
      $('.historyTable').DataTable().columns.adjust();
    });

  }

  dataTableRefreshFunction() {
    this.authorizedEquityShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.issuedEquityShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.subscribedEquityShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.paidupEquityShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.authorizedPreferenceShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.issuedPreferenceShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.subscribedPreferenceShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.paidupPreferenceShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalPaidUpShareCapitalDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };
    this.generalReserveDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.surplusProfitAndLossDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.debitBalanceofStatementofProfitandLossDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]

    };

    this.surplusOthersDataTableDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalFreeReservesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.capitalReserveProceedsReceivedInCashDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.capitalReserveProceedsNotReceivedInCashDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.capitalRedemptionReserveDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.securityPremiumReserveDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.othersDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalReservesOtherThanFreeReservesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalReservesAndSurplusDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.shareCapitalAndFreeReservesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.netWorthDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.turnoverDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.netProfitForManagerialRemunerationDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.netProfitForCSRApplicabilityDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.loanGivenDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.guaranteeOrSecurityGivenDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.acquisitionOfSecuritiesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.loansOthersDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalLoansAndInvestmentsLimitsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.loansfromBankandFinancialInstitutionsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.deferredPaymentLiabilitiesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.depositsLongTermAndShortTermDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.loansandAdvancesfromRelatedPartiesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.longTermMaturitiesofLeaseObligationsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.bondsAndDebenturesDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.othersBorrowingDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalBorrowingDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.shortTermLoansDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.cashCreditArrangementsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.discountingofBiillsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.otherShortTermLoansofSeasonalCharacterDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.outstandingLoansLaonDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.totalTemporaryLoansDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };

    this.borrowingLimitsDtOption = {
      destroy: true,
      scrollY: "400px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateSave: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [1] }]
    };
  }

  // getFinacialData() {
  //   this.newValue = "";
  //   var financialID = localStorage.getItem('financialID');
  //   this.companyMasterService.getfinancialData(financialID).subscribe(data => {
  //     this.financialDataDetails = data.financeDetail[0];
  //     this.bindFinancialDataToUI();
  //   });
  // }
  roundDigit(val) {

    var str = new String(val);
    //console.log(val,'-----length',str.length);
    if (str.length == 1) {
      return (0 + '' + val);
    } else {
      return parseInt(val);
    }
  }


  getFinacialData() {
    this.financialYears = [];
    this.financeServiceRelatedCompany.getCompanyIncorporationDate()
      .subscribe(companyDetails => {
        console.log(companyDetails)
        if (companyDetails.status == 0) {

          this.newfinanceyear = localStorage.getItem('financeyear');

          if (companyDetails.CompanyDetails[0].DateOfIncorporation) {
            var dateOfIncorporation = new Date(this.setFormatDate(companyDetails.CompanyDetails[0].DateOfIncorporation));
            this.globalIncorporationYear = dateOfIncorporation.getFullYear();
            for (var i = this.globalIncorporationYear; i < new Date().getFullYear() + 1; i++) {
              this.financialYears.push({ "name": i + "-" + this.roundDigit((i + 1) % 100) });
              console.log('IF -For', this.financialYears);
            }

          }
          else {
            this.financialYears.push({ "name": new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) % 100 });
            console.log('else -For', this.financialYears);
          }


        }
      });
    this.newValue = "";
    this.activatedRoute.params.subscribe(params => {
      console.log(params)
      if (params['id'] != undefined) {
        var data = {
          module: 'Finance',
          ID: params['id'],
          CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
        }
      console.log(data)

        this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
      console.log(meetingAccess)

          if (meetingAccess.status == 0) {

            this.companyMasterService.getfinancialData(params['id']).subscribe((data:any) => {
      console.log(data)

              this.financialDataDetails = data.financeDetail[0];
              this.bindFinancialDataToUI();
            });


          } else {
            this.authAlert.validateModuleWithPermissions('Finance', params['id'], meetingAccess.companyID, 'edit')
          }
        })
      
      }
    });
  }
  getFinanceBySelectedYear() {

    var financialYear = this.financialDataForm.controls.FinancialYear.value;

    if (financialYear) {
      this.companyMasterService.getFinanceBySelectedYear(financialYear).subscribe((data:any) => {
        if (data.financeDetail.length === 0) {
          let financialYearID = this.financialDataDetails.FinancialYear;
          localStorage.setItem("financialYearID", JSON.stringify(financialYearID));
          this.router.navigate(
            [{ outlets: { 'structure-outlet': ['company', 'financeDetails','add']  } }],
            { relativeTo: this.route.parent });
          // this.router.navigate(['/company/financeDetails/add']);
        }
        else {
          this.financialDataDetails = data.financeDetail[0];
          this.router.navigate(
            [{ outlets: { 'structure-outlet': ['company', 'financeDetails','edit',+ this.financialDataDetails._id]  } }],
            { relativeTo: this.route.parent });
          // this.router.navigate(['/company/financeDetails/edit/' + this.financialDataDetails._id]);
          this.financialDataForm.controls.FinancialYear.setValue(this.financialDataDetails.FinancialYear);
          this.bindFinancialDataToUI();
        }

      });
    }
  }

  bindFinancialDataToUI() {
    let dt;
    this.financialYearvalue = this.financialDataDetails.FinancialYear;
    this.financialDataForm.controls['FinancialYear'].setValue(this.financialDataDetails.FinancialYear);
    console.log("1111", this.financialDataDetails.FinancialYear, this.financialYearvalue);
    // this.financialDataForm.controls['FinancialYear'].setValue(this.financialDataDetails.FinancialYear, {onlySelf: true});
    var yearvalue = this.financialDataDetails.FinancialYear.toString();
    console.log("yearvalue", yearvalue);
    // this.financialDataForm.controls.FinancialYear.setValue('yearvalue',{onlySelf: true});
    // console.log("this.financialDataForm.controls.FinancialYear.setValue(yearvalue)", this.financialDataForm.controls.FinancialYear.setValue(yearvalue));
    var authorizedEquityShareCapitalValue = this.financialDataDetails.AuthorizedEquityShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapital = this.commonFunction.formatToCommaSeperatedNumber(authorizedEquityShareCapitalValue);
    this.financialDataForm.controls.authorizedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(authorizedEquityShareCapitalValue));
    if (this.financialDataDetails.AuthorizedEquityShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.AuthorizedEquityShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateAuthorizedEquityShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateAuthorizedEquityShareCapital.value;
    }
    this.financialDataForm.controls.remarksAuthorizedEquityShareCapital.setValue(this.financialDataDetails.AuthorizedEquityShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalRemarks = this.financialDataDetails.AuthorizedEquityShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalHistory = this.financialDataDetails.AuthorizedEquityShareCapital.History || [];
    this.authorizedEquityShareCapitalDtTrigger.next();

    var issuedEquityShareCapitalValue = this.financialDataDetails.IssuedEquityShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.issuedEquityShareCapital = this.commonFunction.formatToCommaSeperatedNumber(issuedEquityShareCapitalValue);
    this.financialDataForm.controls.issuedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(issuedEquityShareCapitalValue));
    if (this.financialDataDetails.IssuedEquityShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.IssuedEquityShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfIssuedEquityShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.issuedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfIssuedEquityShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfIssuedEquityShareCapital.setValue(this.financialDataDetails.IssuedEquityShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.issuedEquityShareCapitalRemarks = this.financialDataDetails.IssuedEquityShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.issuedEquityShareCapitalHistory = this.financialDataDetails.IssuedEquityShareCapital.History || [];
    this.issuedEquityShareCapitalDtTrigger.next();

    var subscribedEquityShareCapitalValue = this.financialDataDetails.SubscribedShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapital = this.commonFunction.formatToCommaSeperatedNumber(subscribedEquityShareCapitalValue);
    this.financialDataForm.controls.subscribedEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(subscribedEquityShareCapitalValue));
    if (this.financialDataDetails.SubscribedShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.SubscribedShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfsubscribedShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfsubscribedShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfsubscribedShareCapital.setValue(this.financialDataDetails.SubscribedShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalRemarks = this.financialDataDetails.SubscribedShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalHistory = this.financialDataDetails.SubscribedShareCapital.History || [];
    this.subscribedEquityShareCapitalDtTrigger.next();

    var paidupEquityShareCapitalValue = this.financialDataDetails.PaidupEquityShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.paidupEquityShareCapital = this.commonFunction.formatToCommaSeperatedNumber(paidupEquityShareCapitalValue);
    this.financialDataForm.controls.paidupEquityShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(paidupEquityShareCapitalValue));
    if (this.financialDataDetails.PaidupEquityShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.PaidupEquityShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfPaidupEquityShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.paidupEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfPaidupEquityShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfPaidupEquityShareCapital.setValue(this.financialDataDetails.PaidupEquityShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.paidupEquityShareCapitalRemarks = this.financialDataDetails.PaidupEquityShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.paidupEquityShareCapitalHistory = this.financialDataDetails.PaidupEquityShareCapital.History || [];
    this.paidupEquityShareCapitalDtTrigger.next();

    var authorizedPreferenceShareCapitalValue = this.financialDataDetails.AuthorizedPreferenceShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapital = this.commonFunction.formatToCommaSeperatedNumber(authorizedPreferenceShareCapitalValue);
    this.financialDataForm.controls.authorizedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(authorizedPreferenceShareCapitalValue));
    if (this.financialDataDetails.AuthorizedPreferenceShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.AuthorizedPreferenceShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfAuthorizedPreferenceShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfAuthorizedPreferenceShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfAuthorizedPreferenceShareCapital.setValue(this.financialDataDetails.AuthorizedPreferenceShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalRemarks = this.financialDataDetails.AuthorizedPreferenceShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalHistory = this.financialDataDetails.AuthorizedPreferenceShareCapital.History || [];
    this.authorizedPreferenceShareCapitalDtTrigger.next();

    var issuedPreferenceShareCapitalValue = this.financialDataDetails.IssuedPreferenceShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapital = this.commonFunction.formatToCommaSeperatedNumber(issuedPreferenceShareCapitalValue);
    this.financialDataForm.controls.issuedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(issuedPreferenceShareCapitalValue));
    if (this.financialDataDetails.IssuedPreferenceShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.IssuedPreferenceShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfIssuedPreferenceShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfIssuedPreferenceShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfIssuedPreferenceShareCapital.setValue(this.financialDataDetails.IssuedPreferenceShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalRemarks = this.financialDataDetails.IssuedPreferenceShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalHistory = this.financialDataDetails.IssuedPreferenceShareCapital.History || [];
    this.issuedPreferenceShareCapitalDtTrigger.next();

    var subscribedPreferenceShareCapitalValue = this.financialDataDetails.SubscribedPreferenceShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapital = this.commonFunction.formatToCommaSeperatedNumber(subscribedPreferenceShareCapitalValue);
    this.financialDataForm.controls.subscribedPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(subscribedPreferenceShareCapitalValue));
    if (this.financialDataDetails.SubscribedPreferenceShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.SubscribedPreferenceShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfSubscribedPreferenceShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSubscribedPreferenceShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfSubscribedPreferenceShareCapital.setValue(this.financialDataDetails.SubscribedPreferenceShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalRemarks = this.financialDataDetails.SubscribedPreferenceShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalHistory = this.financialDataDetails.SubscribedPreferenceShareCapital.History || [];
    this.subscribedPreferenceShareCapitalDtTrigger.next();

    var paidupPreferenceShareCapitalValue = this.financialDataDetails.PaidupPreferenceShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapital = this.commonFunction.formatToCommaSeperatedNumber(paidupPreferenceShareCapitalValue);
    this.financialDataForm.controls.paidupPreferenceShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(paidupPreferenceShareCapitalValue));
    if (this.financialDataDetails.PaidupPreferenceShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.PaidupPreferenceShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfPaidupPreferenceShareCapital.setValue(effectiveDate);
      this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfPaidupPreferenceShareCapital.value;
    }
    this.financialDataForm.controls.remarksOfPaidupPreferenceShareCapital.setValue(this.financialDataDetails.PaidupPreferenceShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalRemarks = this.financialDataDetails.PaidupPreferenceShareCapital.Remarks;
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalHistory = this.financialDataDetails.PaidupPreferenceShareCapital.History || [];
    this.paidupPreferenceShareCapitalDtTrigger.next();

    var totalPaidUpShareCapitalValue = this.financialDataDetails.TotalPaidUpShareCapital.value || 0;
    this.financialDataDisplay.shareCapital.totalPaidUpShareCapital = this.commonFunction.formatToCommaSeperatedNumber(totalPaidUpShareCapitalValue);
    this.financialDataForm.controls.totalPaidUpShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalPaidUpShareCapitalValue));
    if (this.financialDataDetails.TotalPaidUpShareCapital.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.TotalPaidUpShareCapital.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTotalPaidUpShareCapital.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfTotalPaidUpShareCapital.setValue(this.financialDataDetails.TotalPaidUpShareCapital.Remarks);
    this.financialDataDisplay.shareCapital.totalPaidUpShareCapitalHistory = this.financialDataDetails.TotalPaidUpShareCapital.History || [];
    this.totalPaidUpShareCapitalDtTrigger.next();

    var generalReserveValue = this.financialDataDetails.GeneralReserve.value || 0;
    this.financialDataDisplay.reservesAndSurplus.generalReserve = this.commonFunction.formatToCommaSeperatedNumber(generalReserveValue);
    this.financialDataForm.controls.generalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(generalReserveValue));
    if (this.financialDataDetails.GeneralReserve.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.GeneralReserve.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfGeneralReserve.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.generalReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfGeneralReserve.value;
    }
    this.financialDataForm.controls.remarksOfGeneralReserve.setValue(this.financialDataDetails.GeneralReserve.Remarks);
    this.financialDataDisplay.reservesAndSurplus.generalReserveRemarks = this.financialDataDetails.GeneralReserve.Remarks;
    this.financialDataDisplay.reservesAndSurplus.generalReserveHistory = this.financialDataDetails.GeneralReserve.History || [];
    this.generalReserveDtTrigger.next();

    var surplusProfitAndLossValue = this.financialDataDetails.Surplus.value || 0;
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLoss = this.commonFunction.formatToCommaSeperatedNumber(surplusProfitAndLossValue);
    this.financialDataForm.controls.surplusProfitAndLoss.setValue(this.commonFunction.formatToCommaSeperatedNumber(surplusProfitAndLossValue));
    if (this.financialDataDetails.Surplus.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.Surplus.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfSurplus.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSurplus.value;
    }
    this.financialDataForm.controls.remarksOfSurplus.setValue(this.financialDataDetails.Surplus.Remarks);
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossRemarks = this.financialDataDetails.Surplus.Remarks;
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossHistory = this.financialDataDetails.Surplus.History || [];
    this.surplusProfitAndLossDtTrigger.next();

    var debitBalanceofStatementofProfitandLossValue = this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.value || 0
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLoss = this.commonFunction.formatToCommaSeperatedNumber(debitBalanceofStatementofProfitandLossValue);
    this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.setValue(this.commonFunction.formatToCommaSeperatedNumber(debitBalanceofStatementofProfitandLossValue));
    if (this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfDebitBalanceofStatementofProfitandLoss.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDebitBalanceofStatementofProfitandLoss.value;
    }
    this.financialDataForm.controls.remarksOfDebitBalanceofStatementofProfitandLoss.setValue(this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.Remarks);
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossRemarks = this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.Remarks;
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossHistory = this.financialDataDetails.DebitBalanceofStatementofProfitandLoss.History || [];
    this.debitBalanceofStatementofProfitandLossDtTrigger.next();

    var surplusOthersValue = this.financialDataDetails.SurplusOthers.value || 0
    this.financialDataDisplay.reservesAndSurplus.surplusOthers = this.commonFunction.formatToCommaSeperatedNumber(surplusOthersValue);
    this.financialDataForm.controls.surplusOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(surplusOthersValue));
    if (this.financialDataDetails.SurplusOthers.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.SurplusOthers.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfSurplusOthers.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.surplusOthersEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSurplusOthers.value;
    }
    this.financialDataForm.controls.remarksOfSurplusOthers.setValue(this.financialDataDetails.SurplusOthers.Remarks);
    this.financialDataDisplay.reservesAndSurplus.surplusOthersRemarks = this.financialDataDetails.SurplusOthers.Remarks;
    this.financialDataDisplay.reservesAndSurplus.surplusOthersHistory = this.financialDataDetails.SurplusOthers.History || [];
    this.surplusOthersDataTableDtTrigger.next();

    var totalFreeReservesValue = this.financialDataDetails.TotalFreeReserves.value || 0;
    this.financialDataDisplay.reservesAndSurplus.totalFreeReserve = this.commonFunction.formatToCommaSeperatedNumber(totalFreeReservesValue);
    this.financialDataForm.controls.totalFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalFreeReservesValue));
    if (this.financialDataDetails.TotalFreeReserves.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.TotalFreeReserves.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTotalFreeReserves.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.totalFreeReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfTotalFreeReserves.value;
    }
    this.financialDataDisplay.reservesAndSurplus.totalFreeReserveRemarks = this.financialDataDetails.TotalFreeReserves.Remarks;
    this.financialDataDisplay.reservesAndSurplus.totalFreeReserveHistory = this.financialDataDetails.TotalFreeReserves.History || [];
    this.totalFreeReservesDtTrigger.next();

    var capitalReserveProceedsReceivedInCashValue = this.financialDataDetails.CapitalReserveCash.value || 0;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCash = this.commonFunction.formatToCommaSeperatedNumber(capitalReserveProceedsReceivedInCashValue);
    this.financialDataForm.controls.capitalReserveProceedsReceivedInCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(capitalReserveProceedsReceivedInCashValue));
    if (this.financialDataDetails.CapitalReserveCash.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.CapitalReserveCash.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfCapitalReserveInCash.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalReserveInCash.value;
    }
    this.financialDataForm.controls.remarksOfCapitalReserveInCash.setValue(this.financialDataDetails.CapitalReserveCash.Remarks);
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashRemarks = this.financialDataDetails.CapitalReserveCash.Remarks;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashHistory = this.financialDataDetails.CapitalReserveCash.History || [];
    this.capitalReserveProceedsReceivedInCashDtTrigger.next();

    var capitalReserveProceedsNotReceivedInCashValue = this.financialDataDetails.CapitalReserveNotCash.value || 0;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCash = this.commonFunction.formatToCommaSeperatedNumber(capitalReserveProceedsNotReceivedInCashValue);
    this.financialDataForm.controls.capitalReserveProceedsNotReceivedInCash.setValue(this.commonFunction.formatToCommaSeperatedNumber(capitalReserveProceedsNotReceivedInCashValue));
    if (this.financialDataDetails.CapitalReserveNotCash.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.CapitalReserveNotCash.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfCapitalReserveNotCash.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalReserveNotCash.value;
    }
    this.financialDataForm.controls.remarksOfCapitalReserveNotCash.setValue(this.financialDataDetails.CapitalReserveNotCash.Remarks);
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashRemarks = this.financialDataDetails.CapitalReserveNotCash.Remarks;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashHistory = this.financialDataDetails.CapitalReserveNotCash.History || [];
    this.capitalReserveProceedsNotReceivedInCashDtTrigger.next();

    var capitalRedemptionReserveValue = this.financialDataDetails.CapitalRedemptionReserve.value || 0;
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserve = this.commonFunction.formatToCommaSeperatedNumber(capitalRedemptionReserveValue);
    this.financialDataForm.controls.capitalRedemptionReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(capitalRedemptionReserveValue));
    if (this.financialDataDetails.CapitalRedemptionReserve.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.CapitalRedemptionReserve.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfCapitalRedemptionReserve.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalRedemptionReserve.value;
    }
    this.financialDataForm.controls.remarksOfCapitalRedemptionReserve.setValue(this.financialDataDetails.CapitalRedemptionReserve.Remarks);
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveRemarks = this.financialDataDetails.CapitalRedemptionReserve.Remarks;
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveHistory = this.financialDataDetails.CapitalRedemptionReserve.History || [];
    this.capitalRedemptionReserveDtTrigger.next();

    var securityPremiumReserveValue = this.financialDataDetails.SecurityPremiumReserve.value || 0;
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserve = this.commonFunction.formatToCommaSeperatedNumber(securityPremiumReserveValue);
    this.financialDataForm.controls.securityPremiumReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(securityPremiumReserveValue));
    if (this.financialDataDetails.SecurityPremiumReserve.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.SecurityPremiumReserve.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfSecurityPremiumReserve.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSecurityPremiumReserve.value;
    }
    this.financialDataForm.controls.remarksOfSecurityPremiumReserve.setValue(this.financialDataDetails.SecurityPremiumReserve.Remarks);
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveRemarks = this.financialDataDetails.SecurityPremiumReserve.Remarks;
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveHistory = this.financialDataDetails.SecurityPremiumReserve.History || [];
    this.securityPremiumReserveDtTrigger.next();

    var othersCapitalReserveValue = this.financialDataDetails.OthersCapitalReserve.value || 0
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserve = this.commonFunction.formatToCommaSeperatedNumber(othersCapitalReserveValue);
    this.financialDataForm.controls.othersCapitalReserve.setValue(this.commonFunction.formatToCommaSeperatedNumber(othersCapitalReserveValue));
    if (this.financialDataDetails.OthersCapitalReserve.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.OthersCapitalReserve.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfOthersCapitalReserve.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOthersCapitalReserve.value;
    }
    this.financialDataForm.controls.remarksOfOthersCapitalReserve.setValue(this.financialDataDetails.OthersCapitalReserve.Remarks);
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveRemarks = this.financialDataDetails.OthersCapitalReserve.Remarks;
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveHistory = this.financialDataDetails.OthersCapitalReserve.History || [];
    this.othersDtTrigger.next();

    var totalReservesOtherThanFreeReservesValue = this.financialDataDetails.OtherthanfreeReserves.value || 0;
    this.financialDataDisplay.reservesAndSurplus.totalReservesOtherThanFreeReserves = this.commonFunction.formatToCommaSeperatedNumber(totalReservesOtherThanFreeReservesValue);
    this.financialDataForm.controls.totalReservesOtherThanFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalReservesOtherThanFreeReservesValue));
    if (this.financialDataDetails.OtherthanfreeReserves.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.OtherthanfreeReserves.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTotalReservesOtherThanFreeReserves.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfTotalReservesOtherThanFreeReserves.setValue(this.financialDataDetails.OtherthanfreeReserves.Remarks);
    this.financialDataDisplay.reservesAndSurplus.totalReservesOtherThanFreeReserves = this.financialDataDetails.OtherthanfreeReserves.History || [];
    this.totalReservesOtherThanFreeReservesDtTrigger.next();

    var totalReservesAndSurplusValue = this.financialDataDetails.TotalReservesandSurplus.value || 0;
    this.financialDataDisplay.reservesAndSurplus.totalReservesAndSurplus = this.commonFunction.formatToCommaSeperatedNumber(totalReservesAndSurplusValue);
    this.financialDataForm.controls.totalReservesAndSurplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalReservesAndSurplusValue));
    this.financialDataDisplay.reservesAndSurplus.totalReservesAndSurplusHistory = this.financialDataDetails.TotalReservesandSurplus.History || [];
    this.totalReservesAndSurplusDtTrigger.next();

    var shareCapitalAndFreeReservesValue = this.financialDataDetails.ShareCapitalandFreeReserves.value || 0;
    this.financialDataDisplay.reservesAndSurplus.shareCapitalAndFreeReserves = this.commonFunction.formatToCommaSeperatedNumber(shareCapitalAndFreeReservesValue);
    this.financialDataForm.controls.shareCapitalAndFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(shareCapitalAndFreeReservesValue));
    if (this.financialDataDetails.ShareCapitalandFreeReserves.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.ShareCapitalandFreeReserves.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfShareCapitalAndFreeReserves.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfShareCapitalAndFreeReserves.setValue(this.financialDataDetails.ShareCapitalandFreeReserves.Remarks);
    this.financialDataDisplay.reservesAndSurplus.shareCapitalAndFreeReservesHistory = this.financialDataDetails.ShareCapitalandFreeReserves.History || [];
    this.shareCapitalAndFreeReservesDtTrigger.next();

    var netWorthValue = this.financialDataDetails.NetWorth.value || 0;
    this.financialDataDisplay.reservesAndSurplus.netWorth = this.commonFunction.formatToCommaSeperatedNumber(netWorthValue);
    this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(netWorthValue));
    if (this.financialDataDetails.NetWorth.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.NetWorth.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfNetWorth.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfNetWorth.setValue(this.financialDataDetails.NetWorth.Remarks);
    this.financialDataDisplay.reservesAndSurplus.netWorthHistory = this.financialDataDetails.NetWorth.History || [];
    this.netWorthDtTrigger.next();

    var turnoverValue = this.financialDataDetails.Turnover.value || 0;
    this.financialDataDisplay.reservesAndSurplus.turnover = this.commonFunction.formatToCommaSeperatedNumber(turnoverValue);
    this.financialDataForm.controls.turnover.setValue(this.commonFunction.formatToCommaSeperatedNumber(turnoverValue));
    if (this.financialDataDetails.Turnover.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.Turnover.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTurnover.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.turnoverEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfTurnover.value;
    }
    this.financialDataForm.controls.remarksOfTurnover.setValue(this.financialDataDetails.Turnover.Remarks);
    this.financialDataDisplay.reservesAndSurplus.turnoverRemarks = this.financialDataDetails.Turnover.Remarks;
    this.financialDataDisplay.reservesAndSurplus.turnoverHistory = this.financialDataDetails.Turnover.History || [];
    this.turnoverDtTrigger.next();

    var netProfitForManagerialRemunerationValue = this.financialDataDetails.ManagerialRemunerationNetProfit.value || 0;
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemuneration = this.commonFunction.formatToCommaSeperatedNumber(netProfitForManagerialRemunerationValue);
    this.financialDataForm.controls.netProfitForManagerialRemuneration.setValue(this.commonFunction.formatToCommaSeperatedNumber(netProfitForManagerialRemunerationValue));
    if (this.financialDataDetails.ManagerialRemunerationNetProfit.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.ManagerialRemunerationNetProfit.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfManagerialRemunerationNetProfit.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfManagerialRemunerationNetProfit.value;
    }
    this.financialDataForm.controls.remarksOfManagerialRemunerationNetProfit.setValue(this.financialDataDetails.ManagerialRemunerationNetProfit.Remarks);
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationRemarks = this.financialDataDetails.ManagerialRemunerationNetProfit.Remarks;
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationHistory = this.financialDataDetails.ManagerialRemunerationNetProfit.History || [];
    this.netProfitForManagerialRemunerationDtTrigger.next();

    var netProfitForCSRApplicabilityValue = this.financialDataDetails.CSRApplicabilityNetProfit.value || 0;
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicability = this.commonFunction.formatToCommaSeperatedNumber(netProfitForCSRApplicabilityValue);
    this.financialDataForm.controls.netProfitForCSRApplicability.setValue(this.commonFunction.formatToCommaSeperatedNumber(netProfitForCSRApplicabilityValue));
    if (this.financialDataDetails.CSRApplicabilityNetProfit.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.CSRApplicabilityNetProfit.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfCSRApplicabilityNetProfit.setValue(effectiveDate);
      this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCSRApplicabilityNetProfit.value;
    }
    this.financialDataForm.controls.remarksOfCSRApplicabilityNetProfit.setValue(this.financialDataDetails.CSRApplicabilityNetProfit.Remarks);
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityRemarks = this.financialDataDetails.CSRApplicabilityNetProfit.Remarks;
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityHistory = this.financialDataDetails.CSRApplicabilityNetProfit.History || [];
    this.netProfitForCSRApplicabilityDtTrigger.next();

    var loanGivenValue = this.financialDataDetails.LoanGiven.value || 0;
    this.financialDataDisplay.loanAndInvestMent.loanGiven = this.commonFunction.formatToCommaSeperatedNumber(loanGivenValue);
    this.financialDataForm.controls.loanGiven.setValue(this.commonFunction.formatToCommaSeperatedNumber(loanGivenValue));
    if (this.financialDataDetails.LoanGiven.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.LoanGiven.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfLoanGiven.setValue(effectiveDate);
      this.financialDataDisplay.loanAndInvestMent.loanGivenEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoanGiven.value;
    }
    this.financialDataForm.controls.remarksOfLoanGiven.setValue(this.financialDataDetails.LoanGiven.Remarks);
    this.financialDataDisplay.loanAndInvestMent.loanGivenRemarks = this.financialDataDetails.LoanGiven.Remarks;
    this.financialDataDisplay.loanAndInvestMent.loanGivenHistory = this.financialDataDetails.LoanGiven.History || [];
    this.loanGivenDtTrigger.next();

    var guaranteeOrSecurityGivenValue = this.financialDataDetails.SecurityofLoan.value || 0;
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGiven = this.commonFunction.formatToCommaSeperatedNumber(guaranteeOrSecurityGivenValue);
    this.financialDataForm.controls.guaranteeOrSecurityGiven.setValue(this.commonFunction.formatToCommaSeperatedNumber(guaranteeOrSecurityGivenValue));
    if (this.financialDataDetails.SecurityofLoan.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.SecurityofLoan.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfSecurityofLoan.setValue(effectiveDate);
      this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSecurityofLoan.value;
    }
    this.financialDataForm.controls.remarksOfSecurityofLoan.setValue(this.financialDataDetails.SecurityofLoan.Remarks);
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenRemarks = this.financialDataDetails.SecurityofLoan.Remarks;
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenHistory = this.financialDataDetails.SecurityofLoan.History || [];
    this.guaranteeOrSecurityGivenDtTrigger.next();

    var acquisitionOfSecuritiesValue = this.financialDataDetails.AcquisitionCost.value || 0;
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecurities = this.commonFunction.formatToCommaSeperatedNumber(acquisitionOfSecuritiesValue);
    this.financialDataForm.controls.acquisitionOfSecurities.setValue(this.commonFunction.formatToCommaSeperatedNumber(acquisitionOfSecuritiesValue));
    if (this.financialDataDetails.AcquisitionCost.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.AcquisitionCost.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfAcquisitionCost.setValue(effectiveDate);
      this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfAcquisitionCost.value;
    }
    this.financialDataForm.controls.remarksOfAcquisitionCost.setValue(this.financialDataDetails.AcquisitionCost.Remarks);
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesRemarks = this.financialDataDetails.AcquisitionCost.Remarks;
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesHistory = this.financialDataDetails.AcquisitionCost.History || [];
    this.acquisitionOfSecuritiesDtTrigger.next();

    var loansOthersValue = this.financialDataDetails.LoansOthers.value || 0;
    this.financialDataDisplay.loanAndInvestMent.loansOthers = this.commonFunction.formatToCommaSeperatedNumber(loansOthersValue);
    this.financialDataForm.controls.loansOthers.setValue(this.commonFunction.formatToCommaSeperatedNumber(loansOthersValue));
    if (this.financialDataDetails.LoansOthers.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.LoansOthers.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfLoansOthers.setValue(effectiveDate);
      this.financialDataDisplay.loanAndInvestMent.loansOthersEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansOthers.value;
    }
    this.financialDataForm.controls.remarksOfLoansOthers.setValue(this.financialDataDetails.LoansOthers.Remarks);
    this.financialDataDisplay.loanAndInvestMent.loansOthersRemarks = this.financialDataDetails.LoansOthers.Remarks;
    this.financialDataDisplay.loanAndInvestMent.loansOthersHistory = this.financialDataDetails.LoansOthers.History || [];
    this.loansOthersDtTrigger.next();

    var totalLoansAndInvestmentsLimitsValue = this.financialDataDetails.TotalLoansAndInvestmentsLimits.value || 0;
    this.financialDataDisplay.loanAndInvestMent.totalLoansAndInvestmentsLimits = this.commonFunction.formatToCommaSeperatedNumber(totalLoansAndInvestmentsLimitsValue);
    this.financialDataForm.controls.totalLoansAndInvestmentsLimits.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalLoansAndInvestmentsLimitsValue));
    if (this.financialDataDetails.TotalLoansAndInvestmentsLimits.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.TotalLoansAndInvestmentsLimits.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      // this.financialDataForm.controls.dateOfUpdateOfTotalLoanAndInvestmentLimit.setValue(effectiveDate);
    }
    this.financialDataDisplay.loanAndInvestMent.totalLoansAndInvestmentsLimitsHistory = this.financialDataDetails.TotalLoansAndInvestmentsLimits.History || [];
    this.totalLoansAndInvestmentsLimitsDtTrigger.next();

    var loansfromBankandFinancialInstitutionsValue = this.financialDataDetails.LoansfromBankandFinancialInstitutions.value || 0;
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutions = this.commonFunction.formatToCommaSeperatedNumber(loansfromBankandFinancialInstitutionsValue);
    this.financialDataForm.controls.loansfromBankandFinancialInstitutions.setValue(this.commonFunction.formatToCommaSeperatedNumber(loansfromBankandFinancialInstitutionsValue));
    if (this.financialDataDetails.LoansfromBankandFinancialInstitutions.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.LoansfromBankandFinancialInstitutions.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfLoansfromBankandFinancialInstitutions.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansfromBankandFinancialInstitutions.value;
    }
    this.financialDataForm.controls.remarksOfLoansfromBankandFinancialInstitutions.setValue(this.financialDataDetails.LoansfromBankandFinancialInstitutions.Remarks);
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsRemarks = this.financialDataDetails.LoansfromBankandFinancialInstitutions.Remarks;
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsHistory = this.financialDataDetails.LoansfromBankandFinancialInstitutions.History || [];
    this.loansfromBankandFinancialInstitutionsDtTrigger.next();

    var deferredPaymentLiabilitiesValue = this.financialDataDetails.DeferredPaymentLiabilities.value || 0;
    this.financialDataDisplay.borrowing.deferredPaymentLiabilities = this.commonFunction.formatToCommaSeperatedNumber(deferredPaymentLiabilitiesValue);
    this.financialDataForm.controls.deferredPaymentLiabilities.setValue(this.commonFunction.formatToCommaSeperatedNumber(deferredPaymentLiabilitiesValue));
    if (this.financialDataDetails.DeferredPaymentLiabilities.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.DeferredPaymentLiabilities.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfDeferredPaymentLiabilities.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDeferredPaymentLiabilities.value;
    }
    this.financialDataForm.controls.remarksOfDeferredPaymentLiabilities.setValue(this.financialDataDetails.DeferredPaymentLiabilities.Remarks);
    this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesRemarks = this.financialDataDetails.DeferredPaymentLiabilities.Remarks;
    this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesHistory = this.financialDataDetails.DeferredPaymentLiabilities.History || [];
    this.deferredPaymentLiabilitiesDtTrigger.next();

    var depositsLongTermAndShortTermValue = this.financialDataDetails.Deposits.value || 0;
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTerm = this.commonFunction.formatToCommaSeperatedNumber(depositsLongTermAndShortTermValue);
    this.financialDataForm.controls.depositsLongTermAndShortTerm.setValue(this.commonFunction.formatToCommaSeperatedNumber(depositsLongTermAndShortTermValue));
    if (this.financialDataDetails.Deposits.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.Deposits.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfDeposits.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.depositsLongTermAndShortTermEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDeposits.value;
    }
    this.financialDataForm.controls.remarksOfDeposits.setValue(this.financialDataDetails.Deposits.Remarks);
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTermRemarks = this.financialDataDetails.Deposits.Remarks;
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTermHistory = this.financialDataDetails.Deposits.History || [];
    this.depositsLongTermAndShortTermDtTrigger.next();

    var loansandAdvancesfromRelatedPartiesValue = this.financialDataDetails.LoansandAdvancesfromRelatedParties.value || 0;
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedParties = this.commonFunction.formatToCommaSeperatedNumber(loansandAdvancesfromRelatedPartiesValue);
    this.financialDataForm.controls.loansandAdvancesfromRelatedParties.setValue(this.commonFunction.formatToCommaSeperatedNumber(loansandAdvancesfromRelatedPartiesValue));
    if (this.financialDataDetails.LoansandAdvancesfromRelatedParties.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.LoansandAdvancesfromRelatedParties.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfLoansandAdvancesfromRelatedParties.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansandAdvancesfromRelatedParties.value;
    }
    this.financialDataForm.controls.remarksOfLoansandAdvancesfromRelatedParties.setValue(this.financialDataDetails.LoansandAdvancesfromRelatedParties.Remarks);
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesRemarks = this.financialDataDetails.LoansandAdvancesfromRelatedParties.Remarks;
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesHistory = this.financialDataDetails.LoansandAdvancesfromRelatedParties.History || [];
    this.loansandAdvancesfromRelatedPartiesDtTrigger.next();

    var longTermMaturitiesofLeaseObligationsValue = this.financialDataDetails.LongTermMaturitiesofLeaseObligations.value || 0;
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligations = this.commonFunction.formatToCommaSeperatedNumber(longTermMaturitiesofLeaseObligationsValue);
    this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.setValue(this.commonFunction.formatToCommaSeperatedNumber(longTermMaturitiesofLeaseObligationsValue));
    if (this.financialDataDetails.LongTermMaturitiesofLeaseObligations.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.LongTermMaturitiesofLeaseObligations.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfLongTermMaturitiesofLeaseObligations.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLongTermMaturitiesofLeaseObligations.value;
    }
    this.financialDataForm.controls.remarksOfLongTermMaturitiesofLeaseObligations.setValue(this.financialDataDetails.LongTermMaturitiesofLeaseObligations.Remarks);
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsRemarks = this.financialDataDetails.LongTermMaturitiesofLeaseObligations.Remarks;
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsHistory = this.financialDataDetails.LongTermMaturitiesofLeaseObligations.History || [];
    this.longTermMaturitiesofLeaseObligationsDtTrigger.next();

    var bondsAndDebenturesValue = this.financialDataDetails.BondsDebentures.value || 0;
    this.financialDataDisplay.borrowing.bondsAndDebentures = this.commonFunction.formatToCommaSeperatedNumber(bondsAndDebenturesValue);
    this.financialDataForm.controls.bondsAndDebentures.setValue(this.commonFunction.formatToCommaSeperatedNumber(bondsAndDebenturesValue));
    if (this.financialDataDetails.BondsDebentures.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.BondsDebentures.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfBondsDebentures.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.bondsAndDebenturesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfBondsDebentures.value;
    }
    this.financialDataForm.controls.remarksOfBondsDebentures.setValue(this.financialDataDetails.BondsDebentures.Remarks);
    this.financialDataDisplay.borrowing.bondsAndDebenturesRemarks = this.financialDataDetails.BondsDebentures.Remarks;
    this.financialDataDisplay.borrowing.bondsAndDebenturesHistory = this.financialDataDetails.BondsDebentures.History || [];
    this.bondsAndDebenturesDtTrigger.next();

    var othersBorrowingValue = this.financialDataDetails.OthersBorrowing.value || 0;
    this.financialDataDisplay.borrowing.othersBorrowing = this.commonFunction.formatToCommaSeperatedNumber(othersBorrowingValue);
    this.financialDataForm.controls.othersBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(othersBorrowingValue));
    if (this.financialDataDetails.OthersBorrowing.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.OthersBorrowing.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfOthersBorrowing.setValue(effectiveDate);
      this.financialDataDisplay.borrowing.othersBorrowingEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOthersBorrowing.value;
    }
    this.financialDataForm.controls.remarksOfOthersBorrowing.setValue(this.financialDataDetails.OthersBorrowing.Remarks);
    this.financialDataDisplay.borrowing.othersBorrowingRemarks = this.financialDataDetails.OthersBorrowing.Remarks;
    this.financialDataDisplay.borrowing.othersBorrowingHistory = this.financialDataDetails.OthersBorrowing.History || [];
    this.othersBorrowingDtTrigger.next();

    var totalBorrowingValue = this.financialDataDetails.TotalBorrowingAmount.value || 0;
    this.financialDataDisplay.borrowing.totalBorrowing = this.commonFunction.formatToCommaSeperatedNumber(totalBorrowingValue);
    this.financialDataForm.controls.totalBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalBorrowingValue));
    if (this.financialDataDetails.TotalBorrowingAmount.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.TotalBorrowingAmount.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTotalBorrowing.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfTotalBorrowing.setValue(this.financialDataDetails.TotalBorrowingAmount.Remarks);
    this.financialDataDisplay.borrowing.totalBorrowingHistory = this.financialDataDetails.TotalBorrowingAmount.History || [];
    this.totalBorrowingDtTrigger.next();

    var shortTermLoansValue = this.financialDataDetails.ShortTermLoans.value || 0;
    this.financialDataDisplay.temporaryLoan.shortTermLoans = this.commonFunction.formatToCommaSeperatedNumber(shortTermLoansValue);
    this.financialDataForm.controls.shortTermLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(shortTermLoansValue));
    if (this.financialDataDetails.ShortTermLoans.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.ShortTermLoans.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfShortTermLoans.setValue(effectiveDate);
      this.financialDataDisplay.temporaryLoan.shortTermLoansEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfShortTermLoans.value;
    }
    this.financialDataForm.controls.remarksOfShortTermLoans.setValue(this.financialDataDetails.ShortTermLoans.Remarks);
    this.financialDataDisplay.temporaryLoan.shortTermLoansRemarks = this.financialDataDetails.ShortTermLoans.Remarks;
    this.financialDataDisplay.temporaryLoan.shortTermLoansHistory = this.financialDataDetails.ShortTermLoans.History || [];
    this.shortTermLoansDtTrigger.next();

    var cashCreditArrangementsValue = this.financialDataDetails.CashCreditArrangements.value || 0;
    this.financialDataDisplay.temporaryLoan.cashCreditArrangements = this.commonFunction.formatToCommaSeperatedNumber(cashCreditArrangementsValue);
    this.financialDataForm.controls.cashCreditArrangements.setValue(this.commonFunction.formatToCommaSeperatedNumber(cashCreditArrangementsValue));
    if (this.financialDataDetails.CashCreditArrangements.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.CashCreditArrangements.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfCashCreditArrangements.setValue(effectiveDate);
      this.financialDataDisplay.temporaryLoan.cashCreditArrangementsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCashCreditArrangements.value;
    }
    this.financialDataForm.controls.remarksOfCashCreditArrangements.setValue(this.financialDataDetails.CashCreditArrangements.Remarks);
    this.financialDataDisplay.temporaryLoan.cashCreditArrangementsRemarks = this.financialDataDetails.CashCreditArrangements.Remarks;
    this.financialDataDisplay.temporaryLoan.cashCreditArrangementsHistory = this.financialDataDetails.CashCreditArrangements.History || [];
    this.cashCreditArrangementsDtTrigger.next();

    var discountingofBiillsValue = this.financialDataDetails.DiscountingofBills.value || 0;
    this.financialDataDisplay.temporaryLoan.discountingofBiills = this.commonFunction.formatToCommaSeperatedNumber(discountingofBiillsValue);
    this.financialDataForm.controls.discountingofBiills.setValue(this.commonFunction.formatToCommaSeperatedNumber(discountingofBiillsValue));
    if (this.financialDataDetails.DiscountingofBills.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.DiscountingofBills.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfDiscountingofBills.setValue(effectiveDate);
      this.financialDataDisplay.temporaryLoan.discountingofBiillsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDiscountingofBills.value;
    }
    this.financialDataForm.controls.remarksOfDiscountingofBills.setValue(this.financialDataDetails.DiscountingofBills.Remarks);
    this.financialDataDisplay.temporaryLoan.discountingofBiillsRemarks = this.financialDataDetails.DiscountingofBills.Remarks;
    this.financialDataDisplay.temporaryLoan.discountingofBiillsHistory = this.financialDataDetails.DiscountingofBills.History || [];
    this.discountingofBiillsDtTrigger.next();

    var otherShortTermLoansofSeasonalCharacterValue = this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.value || 0;
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacter = this.commonFunction.formatToCommaSeperatedNumber(otherShortTermLoansofSeasonalCharacterValue);
    this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.setValue(this.commonFunction.formatToCommaSeperatedNumber(otherShortTermLoansofSeasonalCharacterValue));
    if (this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter.setValue(effectiveDate);
      this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter.value;
    }
    this.financialDataForm.controls.remarksOfOtherShortTermLoansofSeasonalCharacter.setValue(this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.Remarks);
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterRemarks = this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.Remarks;
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterHistory = this.financialDataDetails.OtherShortTermLoansofSeasonalCharacter.History || [];
    this.otherShortTermLoansofSeasonalCharacterDtTrigger.next();

    var outstandingLoansValue = this.financialDataDetails.OutstandingLoans.value || 0;
    this.financialDataDisplay.temporaryLoan.outstandingLoans = this.commonFunction.formatToCommaSeperatedNumber(outstandingLoansValue);
    this.financialDataForm.controls.outstandingLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(outstandingLoansValue));
    if (this.financialDataDetails.OutstandingLoans.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.OutstandingLoans.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfOutstandingLoans.setValue(effectiveDate);
      this.financialDataDisplay.temporaryLoan.outstandingLoansEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOutstandingLoans.value;
    }
    this.financialDataForm.controls.remarksOfOutstandingLoans.setValue(this.financialDataDetails.OutstandingLoans.Remarks);
    this.financialDataDisplay.temporaryLoan.outstandingLoansRemarks = this.financialDataDetails.OutstandingLoans.Remarks;
    this.financialDataDisplay.temporaryLoan.outstandingLoansLaonHistory = this.financialDataDetails.OutstandingLoans.History || [];
    this.outstandingLoansLaonDtTrigger.next();

    var totalTemporaryLoansValue = this.financialDataDetails.TotalTemporaryLoansAmount.value || 0;
    this.financialDataDisplay.temporaryLoan.totalTemporaryLoans = this.commonFunction.formatToCommaSeperatedNumber(totalTemporaryLoansValue);
    this.financialDataForm.controls.totalTemporaryLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(totalTemporaryLoansValue));
    if (this.financialDataDetails.TotalTemporaryLoansAmount.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.TotalTemporaryLoansAmount.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfTotalTemporaryLoans.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfTotalTemporaryLoans.setValue(this.financialDataDetails.TotalTemporaryLoansAmount.Remarks);
    this.financialDataDisplay.temporaryLoan.totalTemporaryLoansHistory = this.financialDataDetails.TotalTemporaryLoansAmount.History || [];
    this.totalTemporaryLoansDtTrigger.next();

    var borrowingLimitsValue = this.financialDataDetails.BorrowingLimitsUS180.value || 0;
    this.financialDataDisplay.temporaryLoan.borrowingLimits = this.commonFunction.formatToCommaSeperatedNumber(borrowingLimitsValue);
    this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(borrowingLimitsValue));
    if (this.financialDataDetails.BorrowingLimitsUS180.EffectiveDate != null) {
      dt = new Date(this.setFormatDate(this.financialDataDetails.BorrowingLimitsUS180.EffectiveDate));
      let effectiveDate = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      this.financialDataForm.controls.dateOfUpdateOfBorrowing.setValue(effectiveDate);
    }
    this.financialDataForm.controls.remarksOfBorrowing.setValue(this.financialDataDetails.BorrowingLimitsUS180.Remarks);
    this.financialDataDisplay.temporaryLoan.borrowingLimitsHistory = this.financialDataDetails.BorrowingLimitsUS180.History || [];
    this.borrowingLimitsDtTrigger.next();
  }

  //Authorized Equity Share Capital
  showEditAuthorizedEquitShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#authorizedEquityShareCapital').parent().addClass('editMode');
    var width = $('#authorizedEquityShareCapital').parent().outerWidth();
    $('#edit-authorized-equity-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateAuthorizedEquitShareCapitalValue() {
    $('#edit-authorized-equity-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapital = this.financialDataForm.controls.authorizedEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateAuthorizedEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalRemarks = this.financialDataForm.controls.remarksAuthorizedEquityShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditAditAuthorizedEquitShareCapitalPopup() {
    $('#edit-authorized-equity-share-capital-popup').slideUp();
    $('#authorizedEquityShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.authorizedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedEquityShareCapital);
    this.financialDataForm.controls.dateOfUpdateAuthorizedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksAuthorizedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedEquityShareCapitalRemarks);
  }

  showAuthorizedEquitShareCapitalHistoryPopup() {
    $('#history-authorized-equity-share-capital-popup').modal('show');
  }


  //Issued Equity Share Capital
  showEditIssuedEquityShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#issuedEquityShareCapital').parent().addClass('editMode');
    var width = $('#issuedEquityShareCapital').parent().outerWidth();
    $('#edit-issued-equity-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateIssuedEquityShareCapitalValue() {
    $('#edit-issued-equity-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.issuedEquityShareCapital = this.financialDataForm.controls.issuedEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.issuedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfIssuedEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.issuedEquityShareCapitalRemarks = this.financialDataForm.controls.remarksOfIssuedEquityShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditIssuedEquityShareCapitalPopup() {
    $('#edit-issued-equity-share-capital-popup').slideUp();
    $('#issuedEquityShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.issuedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedEquityShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfIssuedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedEquityShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfIssuedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedEquityShareCapitalRemarks);
  }

  showIssuedEquityShareCapitalHistoryPopup() {
    $("#history-issued-equity-share-capital-popup").modal('show');
  }

  //Subscribed Equity Share Capital
  showEditSubscribedEquityShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#subscribedEquityShareCapital').parent().addClass('editMode');
    var width = $('#subscribedEquityShareCapital').parent().outerWidth();
    $('#edit-subscribed-equity-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateSubscribedEquityShareCapitalValue() {
    $('#edit-subscribed-equity-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapital = this.financialDataForm.controls.subscribedEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfsubscribedShareCapital.value;
    this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalRemarks = this.financialDataForm.controls.remarksOfsubscribedShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditSubscribedEquityShareCapitalPopup() {
    $('#edit-subscribed-equity-share-capital-popup').slideUp();
    $('#subscribedEquityShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.subscribedEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedEquityShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfsubscribedShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfsubscribedShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedEquityShareCapitalRemarks);
  }

  showSubscribedEquityShareCapitalHistoryPopup() {
    $("#history-subscribed-equity-share-capital-popup").modal('show');
  }

  //Paidup Equity Share Capital
  showEditPaidupEquityShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#paidupEquity').parent().addClass('editMode');
    var width = $('#paidupEquity').parent().outerWidth();
    $('#edit-paidup-equity-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updatePaidupEquityShareCapitalValue() {
    $('#edit-paidup-equity-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.paidupEquityShareCapital = this.financialDataForm.controls.paidupEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.paidupEquityShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfPaidupEquityShareCapital.value;
    this.financialDataDisplay.shareCapital.paidupEquityShareCapitalRemarks = this.financialDataForm.controls.remarksOfPaidupEquityShareCapital.value;
    this.paidCalculationAmount();
    this.reserveAndSerlusTotalFreeReserves();
    this.checkfinanceValidation();
  }

  closeEditPaidupEquityShareCapitalPopup() {
    $('#edit-paidup-equity-share-capital-popup').slideUp();
    $('#paidupEquity').parent().removeClass('editMode');
    this.financialDataForm.controls.paidupEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupEquityShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfPaidupEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupEquityShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfPaidupEquityShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupEquityShareCapitalRemarks);
  }

  showPaidupEquityShareCapitalHistoryPopup() {
    $("#history-paidup-equity-share-capital-popup").modal('show');
  }

  //Authorized Preference Share Capital
  showEditAuthorizedPreferenceShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#authorizedPreferenceShareCapital').parent().addClass('editMode');
    var width = $('#authorizedPreferenceShareCapital').parent().outerWidth();
    $('#edit-authorized-preference-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateAuthorizedPreferenceShareCapitalValue() {
    $('#edit-authorized-preference-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapital = this.financialDataForm.controls.authorizedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfAuthorizedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalRemarks = this.financialDataForm.controls.remarksOfAuthorizedPreferenceShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditAuthorizedPreferenceShareCapitalPopup() {
    $('#edit-authorized-preference-share-capital-popup').slideUp();
    $('#authorizedPreferenceShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.authorizedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfAuthorizedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfAuthorizedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.authorizedPreferenceShareCapitalRemarks);
  }

  showAuthorizedPreferenceShareCapitalHistoryPopup() {
    $("#history-authorized-preference-share-capital-popup").modal('show');
  }

  //Issued Preference Share Capital
  showEditIssuedPreferenceShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#issuedPreferenceShareCapital').parent().addClass('editMode');
    var width = $('#issuedPreferenceShareCapital').parent().outerWidth();
    $('#edit-issued-preference-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateIssuedPreferenceShareCapitalValue() {
    $('#edit-issued-preference-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapital = this.financialDataForm.controls.issuedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfIssuedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalRemarks = this.financialDataForm.controls.remarksOfIssuedPreferenceShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditIssuedPreferenceShareCapitalPopup() {
    $('#edit-issued-preference-share-capital-popup').slideUp();
    $('#issuedPreferenceShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.issuedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedPreferenceShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfIssuedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfIssuedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.issuedPreferenceShareCapitalRemarks);
  }

  showIssuedPreferenceShareCapitalHistoryPopup() {
    $("#history-issued-preference-share-capital-popup").modal('show');
  }

  //Subscribed Preference Share Capital
  showEditSubscribedPreferenceShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#subscribedPreferenceShareCapital').parent().addClass('editMode');
    var width = $('#subscribedPreferenceShareCapital').parent().outerWidth();
    $('#edit-subscribed-preference-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateSubscribedPreferenceShareCapitalValue() {
    $('#edit-subscribed-preference-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapital = this.financialDataForm.controls.subscribedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSubscribedPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalRemarks = this.financialDataForm.controls.remarksOfSubscribedPreferenceShareCapital.value;
    this.checkfinanceValidation();
  }

  closeEditSubscribedPreferenceShareCapitalPopup() {
    $('#edit-subscribed-preference-share-capital-popup').slideUp();
    $('#subscribedPreferenceShareCapital').parent().removeClass('editMode');
    this.financialDataForm.controls.subscribedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfSubscribedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfSubscribedPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.subscribedPreferenceShareCapitalRemarks);
  }

  showSubscribedPreferenceShareCapitalHistoryPopup() {
    $("#history-subscribed-preference-share-capital-popup").modal('show');
  }

  //Paidup Preference Share Capital
  showEditPaidupPreferenceShareCapitalPopup() {
    this.closeAllFieldEditPopup();
    $('#paidupPreference').parent().addClass('editMode');
    var width = $('#paidupPreference').parent().outerWidth();
    $('#edit-paidup-preference-share-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updatePaidupPreferenceShareCapitalValue() {
    $('#edit-paidup-preference-share-capital-popup').slideUp();
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapital = this.financialDataForm.controls.paidupPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfPaidupPreferenceShareCapital.value;
    this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalRemarks = this.financialDataForm.controls.remarksOfPaidupPreferenceShareCapital.value;
    this.paidCalculationAmount();
    this.reserveAndSerlusTotalFreeReserves();
    this.checkfinanceValidation();
  }

  closeEditPaidupPreferenceShareCapitalPopup() {
    $('#edit-paidup-preference-share-capital-popup').slideUp();
    $('#paidupPreference').parent().removeClass('editMode');
    this.financialDataForm.controls.paidupPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupPreferenceShareCapital);
    this.financialDataForm.controls.dateOfUpdateOfPaidupPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalEffectiveDate);
    this.financialDataForm.controls.remarksOfPaidupPreferenceShareCapital.setValue(this.financialDataDisplay.shareCapital.paidupPreferenceShareCapitalRemarks);
  }

  showPaidupPreferenceShareCapitalHistoryPopup() {
    $("#history-paidup-preference-share-capital-popup").modal('show');
  }


  //Total Paid up Share Capital
  showTotalPaidupPreferenceShareCapitalHistoryPopup() {
    $("#history-totalPaidup-preference-share-capital-popup").modal('show');
  }

  /**
   * Reverse and Surplus tab
   */
  //General Reserve
  showEditGeneralReservePopup() {
    this.closeAllFieldEditPopup();
    $('#reverse').parent().addClass('editMode');
    var width = $('#reverse').parent().outerWidth();
    $('#edit-general-reserve-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateGeneralReserveValue() {
    $('#edit-general-reserve-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.generalReserve = this.financialDataForm.controls.generalReserve.value;
    this.financialDataDisplay.reservesAndSurplus.generalReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfGeneralReserve.value;
    this.financialDataDisplay.reservesAndSurplus.generalReserveRemarks = this.financialDataForm.controls.remarksOfGeneralReserve.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditGeneralReservePopup() {
    $('#edit-general-reserve-popup').slideUp();
    $('#reverse').parent().removeClass('editMode');
    this.financialDataForm.controls.generalReserve.setValue(this.financialDataDisplay.reservesAndSurplus.generalReserve);
    this.financialDataForm.controls.dateOfUpdateOfGeneralReserve.setValue(this.financialDataDisplay.reservesAndSurplus.generalReserveEffectiveDate);
    this.financialDataForm.controls.remarksOfGeneralReserve.setValue(this.financialDataDisplay.reservesAndSurplus.generalReserveRemarks);
  }

  showGeneralReserveHistoryPopup() {
    $("#history-general-reserve-popup").modal('show');
  }

  //Surplus in P & L
  showEditSurplusPopup() {
    this.closeAllFieldEditPopup();
    $('#surplus').parent().addClass('editMode');
    var width = $('#surplus').parent().outerWidth();
    $('#edit-surplus-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateSurplusValue() {
    $('#edit-surplus-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLoss = this.financialDataForm.controls.surplusProfitAndLoss.value;
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSurplus.value;
    this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossRemarks = this.financialDataForm.controls.remarksOfSurplus.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditSurplusPopup() {
    $('#edit-surplus-popup').slideUp();
    $('#surplus').parent().addClass('editMode');
    this.financialDataForm.controls.surplusProfitAndLoss.setValue(this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLoss);
    this.financialDataForm.controls.dateOfUpdateOfSurplus.setValue(this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossEffectiveDate);
    this.financialDataForm.controls.remarksOfSurplus.setValue(this.financialDataDisplay.reservesAndSurplus.surplusProfitAndLossRemarks);
  }

  showSurplusHistoryPopup() {
    $("#history-surplus-popup").modal('show');
  }

  //Debit Balance in P & L
  showEditDebitBalancePopup() {
    this.closeAllFieldEditPopup();
    $('#debitBalance').parent().addClass('editMode');
    var width = $('#debitBalance').parent().outerWidth();
    $('#edit-debit-balance-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateDebitBalanceValue() {
    $('#edit-debit-balance-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLoss = this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.value;
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDebitBalanceofStatementofProfitandLoss.value;
    this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossRemarks = this.financialDataForm.controls.remarksOfDebitBalanceofStatementofProfitandLoss.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditDebitBalancePopup() {
    $('#edit-debit-balance-popup').slideUp();
    $('#debitBalance').parent().removeClass('editMode');
    this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.setValue(this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLoss);
    this.financialDataForm.controls.dateOfUpdateOfDebitBalanceofStatementofProfitandLoss.setValue(this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossEffectiveDate);
    this.financialDataForm.controls.remarksOfDebitBalanceofStatementofProfitandLoss.setValue(this.financialDataDisplay.reservesAndSurplus.debitBalanceofStatementofProfitandLossRemarks);
  }

  showDebitBalanceHistoryPopup() {
    $("#history-debit-balance-popup").modal('show');
  }

  //Others
  showEditOthersPopup() {
    this.closeAllFieldEditPopup();
    $('#surplusOthers').parent().addClass('editMode');
    var width = $('#surplusOthers').parent().outerWidth();
    $('#edit-others-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateOthersValue() {
    $('#edit-others-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.surplusOthers = this.financialDataForm.controls.surplusOthers.value;
    this.financialDataDisplay.reservesAndSurplus.surplusOthersEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSurplusOthers.value;
    this.financialDataDisplay.reservesAndSurplus.surplusOthersRemarks = this.financialDataForm.controls.remarksOfSurplusOthers.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditOthersPopup() {
    $('#edit-others-popup').slideUp();
    $('#surplusOthers').parent().removeClass('editMode');
    this.financialDataForm.controls.surplusOthers.setValue(this.financialDataDisplay.reservesAndSurplus.surplusOthers);
    this.financialDataForm.controls.dateOfUpdateOfSurplusOthers.setValue(this.financialDataDisplay.reservesAndSurplus.surplusOthersEffectiveDate);
    this.financialDataForm.controls.remarksOfSurplusOthers.setValue(this.financialDataDisplay.reservesAndSurplus.surplusOthersRemarks);
  }

  showOthersHistoryPopup() {
    $("#history-others-popup").modal('show');
  }

  //Total Free Reserves
  showTotalFreeReservesHistoryPopup() {
    $("#history-total-free-reserve-popup").modal('show');
  }

  //Capital Reserve (proceeds received in cash)
  showEditCapitalReserveInCashPopup() {
    this.closeAllFieldEditPopup();
    $('#capitalReserve').parent().addClass('editMode');
    var width = $('#capitalReserve').parent().outerWidth();
    $('#edit-capital-reserve-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateCapitalReserveInCashValue() {
    $('#edit-capital-reserve-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCash = this.financialDataForm.controls.capitalReserveProceedsReceivedInCash.value;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalReserveInCash.value;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashRemarks = this.financialDataForm.controls.remarksOfCapitalReserveInCash.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditCapitalReserveInCashPopup() {
    $('#edit-capital-reserve-popup').slideUp();
    $('#capitalReserve').parent().removeClass('editMode');
    this.financialDataForm.controls.capitalReserveProceedsReceivedInCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCash);
    this.financialDataForm.controls.dateOfUpdateOfCapitalReserveInCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashEffectiveDate);
    this.financialDataForm.controls.remarksOfCapitalReserveInCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsReceivedInCashRemarks);
  }

  showCapitalReserveInCashHistoryPopup() {
    $("#history-capital-reserve-popup").modal('show');
  }

  //Capital Reserve (proceeds not received in cash)
  showEditCapitalReserveNotCashPopup() {
    this.closeAllFieldEditPopup();
    $('#capitalReserveNotCash').parent().addClass('editMode');
    var width = $('#capitalReserveNotCash').parent().outerWidth();
    $('#edit-capital-reserve-not-cash-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateCapitalReserveNotCashValue() {
    $('#edit-capital-reserve-not-cash-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCash = this.financialDataForm.controls.capitalReserveProceedsNotReceivedInCash.value;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalReserveNotCash.value;
    this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashRemarks = this.financialDataForm.controls.remarksOfCapitalReserveNotCash.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditCapitalReserveNotCashPopup() {
    $('#edit-capital-reserve-not-cash-popup').slideUp();
    $('#capitalReserveNotCash').parent().removeClass('editMode');
    this.financialDataForm.controls.capitalReserveProceedsNotReceivedInCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCash);
    this.financialDataForm.controls.dateOfUpdateOfCapitalReserveNotCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashEffectiveDate);
    this.financialDataForm.controls.remarksOfCapitalReserveNotCash.setValue(this.financialDataDisplay.reservesAndSurplus.capitalReserveProceedsNotReceivedInCashRemarks);
  }

  showCapitalReserveNotCashHistoryPopup() {
    $("#history-capital-reserve-not-cash-popup").modal('show');
  }

  //Capital Redemption Reserve (In excess of Preference shares redeemed)
  showEditCapitalRedemptionReservePopup() {
    this.closeAllFieldEditPopup();
    $('#capitalRedemptionReserve').parent().addClass('editMode');
    var width = $('#capitalRedemptionReserve').parent().outerWidth();
    $('#edit-capital-redemption-reserve-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateCapitalRedemptionReserveValue() {
    $('#edit-capital-redemption-reserve-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserve = this.financialDataForm.controls.capitalRedemptionReserve.value;
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCapitalRedemptionReserve.value;
    this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveRemarks = this.financialDataForm.controls.remarksOfCapitalRedemptionReserve.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditCapitalRedemptionReservePopup() {
    $('#edit-capital-redemption-reserve-popup').slideUp();
    $('#capitalRedemptionReserve').parent().removeClass('editMode');
    this.financialDataForm.controls.capitalRedemptionReserve.setValue(this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserve);
    this.financialDataForm.controls.dateOfUpdateOfCapitalRedemptionReserve.setValue(this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveEffectiveDate);
    this.financialDataForm.controls.remarksOfCapitalRedemptionReserve.setValue(this.financialDataDisplay.reservesAndSurplus.capitalRedemptionReserveRemarks);
  }

  showCapitalRedemptionReserveHistoryPopup() {
    $("#history-capital-redemption-reserve-popup").modal('show');
  }

  //Security Premium Reserve
  showEditSecurityPremiumReservePopup() {
    this.closeAllFieldEditPopup();
    $('#securityPremiumReserve').parent().addClass('editMode');
    var width = $('#securityPremiumReserve').parent().outerWidth();
    $('#edit-Security-premium-reserve-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateSecurityPremiumReserveValue() {
    $('#edit-Security-premium-reserve-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserve = this.financialDataForm.controls.securityPremiumReserve.value;
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSecurityPremiumReserve.value;
    this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveRemarks = this.financialDataForm.controls.remarksOfSecurityPremiumReserve.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditSecurityPremiumReservePopup() {
    $('#edit-Security-premium-reserve-popup').slideUp();
    $('#securityPremiumReserve').parent().removeClass('editMode');
    this.financialDataForm.controls.securityPremiumReserve.setValue(this.financialDataDisplay.reservesAndSurplus.securityPremiumReserve);
    this.financialDataForm.controls.dateOfUpdateOfSecurityPremiumReserve.setValue(this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveEffectiveDate);
    this.financialDataForm.controls.remarksOfSecurityPremiumReserve.setValue(this.financialDataDisplay.reservesAndSurplus.securityPremiumReserveRemarks);
  }

  showSecurityPremiumReserveHistoryPopup() {
    $("#history-Security-premium-reserve-popup").modal('show');
  }

  //Others
  showEditOthersCapitalReservePopup() {
    this.closeAllFieldEditPopup();
    $('#others').parent().addClass('editMode');
    var width = $('#others').parent().outerWidth();
    $('#edit-others-capital-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateOthersCapitalReserveValue() {
    $('#edit-others-capital-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserve = this.financialDataForm.controls.othersCapitalReserve.value;
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOthersCapitalReserve.value;
    this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveRemarks = this.financialDataForm.controls.remarksOfOthersCapitalReserve.value;
    this.reserveAndSerlusTotalFreeReserves();
  }

  closeEditOthersCapitalReservePopup() {
    $('#edit-others-capital-popup').slideUp();
    $('#others').parent().removeClass('editMode');
    this.financialDataForm.controls.othersCapitalReserve.setValue(this.financialDataDisplay.reservesAndSurplus.othersCapitalReserve);
    this.financialDataForm.controls.dateOfUpdateOfOthersCapitalReserve.setValue(this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveEffectiveDate);
    this.financialDataForm.controls.remarksOfOthersCapitalReserve.setValue(this.financialDataDisplay.reservesAndSurplus.othersCapitalReserveRemarks);
  }

  showOthersCapitalReserveHistoryPopup() {
    $("#history-others-capital-popup").modal('show');
  }

  //Total Reserves other than Free Reserves
  showTotalReservesOtherThanFreeReservesHistoryPopup() {
    $("#history-total-reserves-other-than-free-reserves-popup").modal('show');
  }

  //Total Reserves and Surplus
  showTotalReservesAndSurplusHistoryPopup() {
    $("#history-total-reserves-and-surplus-popup").modal('show');
  }

  //Share Capital and Free Reserves
  showShareCapitalAndFreeReservesHistoryPopup() {
    $("#history-share-capital-and-free-reserves-popup").modal('show');
  }

  //Net Worth
  showNetWorthHistoryPopup() {
    $("#history-net-worth-popup").modal('show');
  }

  //Turnover
  showEditTurnoverPopup() {
    this.closeAllFieldEditPopup();
    $('#turnover').parent().addClass('editMode');
    var width = $('#turnover').parent().outerWidth();
    $('#edit-turnover-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateTurnoverValue() {
    $('#edit-turnover-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.turnover = this.financialDataForm.controls.turnover.value;
    this.financialDataDisplay.reservesAndSurplus.turnoverEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfTurnover.value;
    this.financialDataDisplay.reservesAndSurplus.turnoverRemarks = this.financialDataForm.controls.remarksOfTurnover.value;
  }

  closeEditTurnoverPopup() {
    $('#edit-turnover-popup').slideUp();
    $('#turnover').parent().removeClass('editMode');
    this.financialDataForm.controls.turnover.setValue(this.financialDataDisplay.reservesAndSurplus.turnover);
    this.financialDataForm.controls.dateOfUpdateOfTurnover.setValue(this.financialDataDisplay.reservesAndSurplus.turnoverEffectiveDate);
    this.financialDataForm.controls.remarksOfTurnover.setValue(this.financialDataDisplay.reservesAndSurplus.turnoverRemarks);
  }

  showTurnoverHistoryPopup() {
    $("#history-turnover-popup").modal('show');
  }

  //Net Profit (For managerial remuneration)
  showEditNetProfitManagerialRemunerationPopup() {
    this.closeAllFieldEditPopup();
    $('#netProfit').parent().addClass('editMode');
    var width = $('#netProfit').parent().outerWidth();
    $('#edit-net-profit-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateNetProfitManagerialRemunerationValue() {
    $('#edit-net-profit-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemuneration = this.financialDataForm.controls.netProfitForManagerialRemuneration.value;
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfManagerialRemunerationNetProfit.value;
    this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationRemarks = this.financialDataForm.controls.remarksOfManagerialRemunerationNetProfit.value;
  }

  closeEditNetProfitManagerialRemunerationPopup() {
    $('#edit-net-profit-popup').slideUp();
    $('#netProfit').parent().removeClass('editMode');
    this.financialDataForm.controls.netProfitForManagerialRemuneration.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemuneration);
    this.financialDataForm.controls.dateOfUpdateOfManagerialRemunerationNetProfit.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationEffectiveDate);
    this.financialDataForm.controls.remarksOfManagerialRemunerationNetProfit.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForManagerialRemunerationRemarks);
  }

  showNetProfitManagerialRemunerationHistoryPopup() {
    $("#history-net-profit-managerial-remuneration-popup").modal('show');
  }

  //Net Profit (For CSR Applicability)
  showEditCSRApplicabilityNetProfitPopup() {
    this.closeAllFieldEditPopup();
    $('#netProfitCsrCapability').parent().addClass('editMode');
    var width = $('#netProfitCsrCapability').parent().outerWidth();
    $('#edit-net-profit-CSR-applicability-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateCSRApplicabilityNetProfitValue() {
    $('#edit-net-profit-CSR-applicability-popup').slideUp();
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicability = this.financialDataForm.controls.netProfitForCSRApplicability.value;
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCSRApplicabilityNetProfit.value;
    this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityRemarks = this.financialDataForm.controls.remarksOfCSRApplicabilityNetProfit.value;
  }

  closeEditCSRApplicabilityNetProfitPopup() {
    $('#edit-net-profit-CSR-applicability-popup').slideUp();
    $('#netProfitCsrCapability').parent().removeClass('editMode');
    this.financialDataForm.controls.netProfitForCSRApplicability.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicability);
    this.financialDataForm.controls.dateOfUpdateOfCSRApplicabilityNetProfit.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityEffectiveDate);
    this.financialDataForm.controls.remarksOfCSRApplicabilityNetProfit.setValue(this.financialDataDisplay.reservesAndSurplus.netProfitForCSRApplicabilityRemarks);
  }

  showCSRApplicabilityNetProfitHistoryPopup() {
    $("#history-net-profit-CSR-applicability-popup").modal('show');
  }

  /**
 * Loan And Investment Tab
 */
  //Loans given
  showEditLoansGivenPopup() {
    this.closeAllFieldEditPopup();
    $('#loanGiven').parent().addClass('editMode');
    var width = $('#loanGiven').parent().outerWidth();
    $('#edit-loans-given-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateLoansGivenValue() {
    $('#edit-loans-given-popup').slideUp();
    this.financialDataDisplay.loanAndInvestMent.loanGiven = this.financialDataForm.controls.loanGiven.value;
    this.financialDataDisplay.loanAndInvestMent.loanGivenEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoanGiven.value;
    this.financialDataDisplay.loanAndInvestMent.loanGivenRemarks = this.financialDataForm.controls.remarksOfLoanGiven.value;
    this.loanAndInvestMent();
  }

  closeEditLoansGivenPopup() {
    $('#edit-loans-given-popup').slideUp();
    $('#loanGiven').parent().removeClass('editMode');
    this.financialDataForm.controls.loanGiven.setValue(this.financialDataDisplay.loanAndInvestMent.loanGiven);
    this.financialDataForm.controls.dateOfUpdateOfLoanGiven.setValue(this.financialDataDisplay.loanAndInvestMent.loanGivenEffectiveDate);
    this.financialDataForm.controls.remarksOfLoanGiven.setValue(this.financialDataDisplay.loanAndInvestMent.loanGivenRemarks);
  }

  showLoansGivenHistoryPopup() {
    $("#history-loans-given-popup").modal('show');
  }

  //Guarantee or security given
  showEditGuaranteePopup() {
    this.closeAllFieldEditPopup();
    $('#guaranteeAmount').parent().addClass('editMode');
    var width = $('#guaranteeAmount').parent().outerWidth();
    $('#edit-guarantee-security-CSR-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateGuaranteeValue() {
    $('#edit-guarantee-security-CSR-popup').slideUp();
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGiven = this.financialDataForm.controls.guaranteeOrSecurityGiven.value;
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfSecurityofLoan.value;
    this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenRemarks = this.financialDataForm.controls.remarksOfSecurityofLoan.value;
    this.loanAndInvestMent();
  }

  closeEditGuaranteePopup() {
    $('#edit-guarantee-security-CSR-popup').slideUp();
    $('#guaranteeAmount').parent().removeClass('editMode');
    this.financialDataForm.controls.guaranteeOrSecurityGiven.setValue(this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGiven);
    this.financialDataForm.controls.dateOfUpdateOfSecurityofLoan.setValue(this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenEffectiveDate);
    this.financialDataForm.controls.remarksOfSecurityofLoan.setValue(this.financialDataDisplay.loanAndInvestMent.guaranteeOrSecurityGivenRemarks);
  }

  showGuaranteeHistoryPopup() {
    $("#history-guarantee-security-CSR-popup").modal('show');
  }

  //Acquisition of securities
  showEditAcquisitionofsecuritiesPopup() {
    this.closeAllFieldEditPopup();
    $('#acquisitionAmount').parent().addClass('editMode');
    var width = $('#acquisitionAmount').parent().outerWidth();
    $('#edit-acquisition-of-securities-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateAcquisitionofsecuritiesValue() {
    $('#edit-acquisition-of-securities-popup').slideUp();
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecurities = this.financialDataForm.controls.acquisitionOfSecurities.value;
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfAcquisitionCost.value;
    this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesRemarks = this.financialDataForm.controls.remarksOfAcquisitionCost.value;
    this.loanAndInvestMent();
  }

  closeEditAcquisitionofsecuritiesPopup() {
    $('#edit-acquisition-of-securities-popup').slideUp();
    $('#acquisitionAmount').parent().removeClass('editMode');
    this.financialDataForm.controls.acquisitionOfSecurities.setValue(this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecurities);
    this.financialDataForm.controls.dateOfUpdateOfAcquisitionCost.setValue(this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesEffectiveDate);
    this.financialDataForm.controls.remarksOfAcquisitionCost.setValue(this.financialDataDisplay.loanAndInvestMent.acquisitionOfSecuritiesRemarks);
  }

  showAcquisitionofsecuritiesHistoryPopup() {
    $("#history-acquisition-of-securities-popup").modal('show');
  }

  //Others Loan Amount 
  showEditLoansOthersAmountPopup() {
    this.closeAllFieldEditPopup();
    $('#loansOthersAmount').parent().addClass('editMode');
    var width = $('#loansOthersAmount').parent().outerWidth();
    $('#edit-loans-others-amount-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateLoansOthersAmountValue() {
    $('#edit-loans-others-amount-popup').slideUp();
    this.financialDataDisplay.loanAndInvestMent.loansOthers = this.financialDataForm.controls.loansOthers.value;
    this.financialDataDisplay.loanAndInvestMent.loansOthersEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansOthers.value;
    this.financialDataDisplay.loanAndInvestMent.loansOthersRemarks = this.financialDataForm.controls.remarksOfLoansOthers.value;
    this.loanAndInvestMent();
  }

  closeEditLoansOthersAmountPopup() {
    $('#edit-loans-others-amount-popup').slideUp();
    $('#loansOthersAmount').parent().removeClass('editMode');
    this.financialDataForm.controls.loansOthers.setValue(this.financialDataDisplay.loanAndInvestMent.loansOthers);
    this.financialDataForm.controls.dateOfUpdateOfLoansOthers.setValue(this.financialDataDisplay.loanAndInvestMent.loansOthersEffectiveDate);
    this.financialDataForm.controls.remarksOfLoansOthers.setValue(this.financialDataDisplay.loanAndInvestMent.loansOthersRemarks);
  }

  showLoansOthersAmountHistoryPopup() {
    $("#history-loans-others-amount-popup").modal('show');
  }

  //Total Loans and Investments (Limits u/s 186)
  showTotalLoansAndInvestmentsHistoryPopup() {
    $("#history-total-loans-and-investments-popup").modal('show');
  }

  /**
   * Borowing Tab  
   */

  //Loans from Bank and Financial Institutions 
  showEditLoansfromBankPopup() {
    this.closeAllFieldEditPopup();
    $('#loansfromBank').parent().addClass('editMode');
    var width = $('#loansfromBank').parent().outerWidth();
    $('#edit-loans-from-bank-and-financial-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateLoansfromBankValue() {
    $('#edit-loans-from-bank-and-financial-popup').slideUp();
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutions = this.financialDataForm.controls.loansfromBankandFinancialInstitutions.value;
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansfromBankandFinancialInstitutions.value;
    this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsRemarks = this.financialDataForm.controls.remarksOfLoansfromBankandFinancialInstitutions.value;
    this.borrowingAmount();
  }

  closeEditLoansfromBankPopup() {
    $('#edit-loans-from-bank-and-financial-popup').slideUp();
    $('#loansfromBank').parent().removeClass('editMode');
    this.financialDataForm.controls.loansfromBankandFinancialInstitutions.setValue(this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutions);
    this.financialDataForm.controls.dateOfUpdateOfLoansfromBankandFinancialInstitutions.setValue(this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsEffectiveDate);
    this.financialDataForm.controls.remarksOfLoansfromBankandFinancialInstitutions.setValue(this.financialDataDisplay.borrowing.loansfromBankandFinancialInstitutionsRemarks);
  }

  showLoansfromBankHistoryPopup() {
    $("#history-loans-from-bank-and-financial-popup").modal('show');
  }

  //Deferred Payment Liabilities
  showEditDeferredPaymentLiabilitiesPopup() {
    this.closeAllFieldEditPopup();
    $('#deferredPayment').parent().addClass('editMode');
    var width = $('#deferredPayment').parent().outerWidth();
    $('#edit-deferred-payment-liabilities-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateDeferredPaymentLiabilitiesValue() {
    $('#edit-deferred-payment-liabilities-popup').slideUp();
    this.financialDataDisplay.borrowing.deferredPaymentLiabilities = this.financialDataForm.controls.deferredPaymentLiabilities.value;
    this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDeferredPaymentLiabilities.value;
    this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesRemarks = this.financialDataForm.controls.remarksOfDeferredPaymentLiabilities.value;
    this.borrowingAmount();
  }

  closeEditDeferredPaymentLiabilitiesPopup() {
    $('#edit-deferred-payment-liabilities-popup').slideUp();
    $('#deferredPayment').parent().removeClass('editMode');
    this.financialDataForm.controls.deferredPaymentLiabilities.setValue(this.financialDataDisplay.borrowing.deferredPaymentLiabilities);
    this.financialDataForm.controls.dateOfUpdateOfDeferredPaymentLiabilities.setValue(this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesEffectiveDate);
    this.financialDataForm.controls.remarksOfDeferredPaymentLiabilities.setValue(this.financialDataDisplay.borrowing.deferredPaymentLiabilitiesRemarks);
  }

  showDeferredPaymentLiabilitiesHistoryPopup() {
    $("#history-deferred-payment-liabilities-popup").modal('show');
  }

  //Deposits(long term and short term)
  showEditDepositsLongTermAndShortTermPopup() {
    this.closeAllFieldEditPopup();
    $('#deposits').parent().addClass('editMode');
    var width = $('#deposits').parent().outerWidth();
    $('#edit-deposits-long-and-short-term-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateDepositsLongTermAndShortTermValue() {
    $('#edit-deposits-long-and-short-term-popup').slideUp();
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTerm = this.financialDataForm.controls.depositsLongTermAndShortTerm.value;
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTermEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDeposits.value;
    this.financialDataDisplay.borrowing.depositsLongTermAndShortTermRemarks = this.financialDataForm.controls.remarksOfDeposits.value;
    this.borrowingAmount();
  }

  closeEditDepositsLongTermAndShortTermPopup() {
    $('#edit-deposits-long-and-short-term-popup').slideUp();
    $('#deposits').parent().removeClass('editMode');
    this.financialDataForm.controls.depositsLongTermAndShortTerm.setValue(this.financialDataDisplay.borrowing.depositsLongTermAndShortTerm);
    this.financialDataForm.controls.dateOfUpdateOfDeposits.setValue(this.financialDataDisplay.borrowing.depositsLongTermAndShortTermEffectiveDate);
    this.financialDataForm.controls.remarksOfDeposits.setValue(this.financialDataDisplay.borrowing.depositsLongTermAndShortTermRemarks);
  }

  showDepositsLongTermAndShortTermHistoryPopup() {
    $("#history-deposits-long-and-short-term-popup").modal('show');
  }


  //Loans and Advances
  showEditLoansandAdvancesfromRelatedPartiesPopup() {
    this.closeAllFieldEditPopup();
    $('#loansandAdvances').parent().addClass('editMode');
    var width = $('#loansandAdvances').parent().outerWidth();
    $('#edit-loans-and-advances-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateLoansandAdvancesfromRelatedPartiesValue() {
    $('#edit-loans-and-advances-popup').slideUp();
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedParties = this.financialDataForm.controls.loansandAdvancesfromRelatedParties.value;
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLoansandAdvancesfromRelatedParties.value;
    this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesRemarks = this.financialDataForm.controls.remarksOfLoansandAdvancesfromRelatedParties.value;
    this.borrowingAmount();
  }

  closeEditLoansandAdvancesfromRelatedPartiesPopup() {
    $('#edit-loans-and-advances-popup').slideUp();
    $('#loansandAdvances').parent().removeClass('editMode');
    this.financialDataForm.controls.loansandAdvancesfromRelatedParties.setValue(this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedParties);
    this.financialDataForm.controls.dateOfUpdateOfLoansandAdvancesfromRelatedParties.setValue(this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesEffectiveDate);
    this.financialDataForm.controls.remarksOfLoansandAdvancesfromRelatedParties.setValue(this.financialDataDisplay.borrowing.loansandAdvancesfromRelatedPartiesRemarks);
  }

  showLoansandAdvancesfromRelatedPartiesHistoryPopup() {
    $("#history-loans-and-advances-popup").modal('show');
  }

  //Long Term Maturities of Lease Obligations
  showEditLongTermMaturitiesOfLeaseObligationsPopup() {
    this.closeAllFieldEditPopup();
    $('#longTermMaturities').parent().addClass('editMode');
    var width = $('#longTermMaturities').parent().outerWidth();
    $('#edit-long-term-maturities-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateLongTermMaturitiesOfLeaseObligationsValue() {
    $('#edit-long-term-maturities-popup').slideUp();
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligations = this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.value;
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfLongTermMaturitiesofLeaseObligations.value;
    this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsRemarks = this.financialDataForm.controls.remarksOfLongTermMaturitiesofLeaseObligations.value;
    this.borrowingAmount();
  }

  closeEditLongTermMaturitiesOfLeaseObligationsPopup() {
    $('#edit-long-term-maturities-popup').slideUp();
    $('#longTermMaturities').parent().removeClass('editMode');
    this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.setValue(this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligations);
    this.financialDataForm.controls.dateOfUpdateOfLongTermMaturitiesofLeaseObligations.setValue(this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsEffectiveDate);
    this.financialDataForm.controls.remarksOfLongTermMaturitiesofLeaseObligations.setValue(this.financialDataDisplay.borrowing.longTermMaturitiesofLeaseObligationsRemarks);
  }

  showLongTermMaturitiesOfLeaseObligationsHistoryPopup() {
    $("#history-long-term-maturities-popup").modal('show');
  }

  //Bonds and Debentures
  showEditBondsAndDebenturesPopup() {
    this.closeAllFieldEditPopup();
    $('#bondsDebentures').parent().addClass('editMode');
    var width = $('#bondsDebentures').parent().outerWidth();
    $('#edit-bonds-and-debentures-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateBondsAndDebenturesValue() {
    $('#edit-bonds-and-debentures-popup').slideUp();
    this.financialDataDisplay.borrowing.bondsAndDebentures = this.financialDataForm.controls.bondsAndDebentures.value;
    this.financialDataDisplay.borrowing.bondsAndDebenturesEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfBondsDebentures.value;
    this.financialDataDisplay.borrowing.bondsAndDebenturesRemarks = this.financialDataForm.controls.remarksOfBondsDebentures.value;
    this.borrowingAmount();
  }

  closeEditBondsAndDebenturesPopup() {
    $('#edit-bonds-and-debentures-popup').slideUp();
    $('#bondsDebentures').parent().removeClass('editMode');
    this.financialDataForm.controls.bondsAndDebentures.setValue(this.financialDataDisplay.borrowing.bondsAndDebentures);
    this.financialDataForm.controls.dateOfUpdateOfBondsDebentures.setValue(this.financialDataDisplay.borrowing.bondsAndDebenturesEffectiveDate);
    this.financialDataForm.controls.remarksOfBondsDebentures.setValue(this.financialDataDisplay.borrowing.bondsAndDebenturesRemarks);
  }

  showBondsAndDebenturesHistoryPopup() {
    $("#history-bonds-and-debentures-popup").modal('show');
  }

  //Others Borrowing
  showEditOthersBorrowingPopup() {
    this.closeAllFieldEditPopup();
    $('#othersBorrowingEditPopUp').parent().addClass('editMode');
    var width = $('#othersBorrowingEditPopUp').parent().outerWidth();
    $('#edit-others-borrowing-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateOthersBorrowingValue() {
    $('#edit-others-borrowing-popup').slideUp();
    this.financialDataDisplay.borrowing.othersBorrowing = this.financialDataForm.controls.othersBorrowing.value;
    this.financialDataDisplay.borrowing.othersBorrowingEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOthersBorrowing.value;
    this.financialDataDisplay.borrowing.othersBorrowingRemarks = this.financialDataForm.controls.remarksOfOthersBorrowing.value;
    this.borrowingAmount();
  }

  closeEditOthersBorrowingPopup() {
    $('#edit-others-borrowing-popup').slideUp();
    $('#othersBorrowingEditPopUp').parent().removeClass('editMode');
    this.financialDataForm.controls.othersBorrowing.setValue(this.financialDataDisplay.borrowing.othersBorrowing);
    this.financialDataForm.controls.dateOfUpdateOfOthersBorrowing.setValue(this.financialDataDisplay.borrowing.othersBorrowingEffectiveDate);
    this.financialDataForm.controls.remarksOfOthersBorrowing.setValue(this.financialDataDisplay.borrowing.othersBorrowingRemarks);
  }

  showOthersBorrowingHistoryPopup() {
    $("#history-others-borrowing-popup").modal('show');
  }

  // Total Borrowing
  showTotalBorrowingHistoryPopup() {
    $("#history-total-borrowing-popup").modal('show');
  }

  /**
   * Temporary Loan Tab
   */
  //Short Term Loans
  showEditShortTermLoansPopup() {
    this.closeAllFieldEditPopup();
    $('#shortTermLoans').parent().addClass('editMode');
    var width = $('#shortTermLoans').parent().outerWidth();
    $('#edit-short-term-loans-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateShortTermLoansValue() {
    $('#edit-short-term-loans-popup').slideUp();
    this.financialDataDisplay.temporaryLoan.shortTermLoans = this.financialDataForm.controls.shortTermLoans.value;
    this.financialDataDisplay.temporaryLoan.shortTermLoansEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfShortTermLoans.value;
    this.financialDataDisplay.temporaryLoan.shortTermLoansRemarks = this.financialDataForm.controls.remarksOfShortTermLoans.value;
    this.temporaryLoansAmount();
  }

  closeEditShortTermLoansPopup() {
    $('#edit-short-term-loans-popup').slideUp();
    $('#shortTermLoans').parent().removeClass('editMode');
    this.financialDataForm.controls.shortTermLoans.setValue(this.financialDataDisplay.temporaryLoan.shortTermLoans);
    this.financialDataForm.controls.dateOfUpdateOfShortTermLoans.setValue(this.financialDataDisplay.temporaryLoan.shortTermLoansEffectiveDate);
    this.financialDataForm.controls.remarksOfShortTermLoans.setValue(this.financialDataDisplay.temporaryLoan.shortTermLoansRemarks);
  }

  showShortTermLoansHistoryPopup() {
    $("#history-short-term-loans-popup").modal('show');
  }

  //Cash Credit Arrangements
  showEditCashCreditArrangementsPopup() {
    this.closeAllFieldEditPopup();
    $('#cashCreditArrangements').parent().addClass('editMode');
    var width = $('#cashCreditArrangements').parent().outerWidth();
    $('#edit-cash-credit-arrangements-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateCashCreditArrangementsValue() {
    $('#edit-cash-credit-arrangements-popup').slideUp();
    this.financialDataDisplay.temporaryLoan.cashCreditArrangements = this.financialDataForm.controls.cashCreditArrangements.value;
    this.financialDataDisplay.temporaryLoan.cashCreditArrangementsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfCashCreditArrangements.value;
    this.financialDataDisplay.temporaryLoan.cashCreditArrangementsRemarks = this.financialDataForm.controls.remarksOfCashCreditArrangements.value;
    this.temporaryLoansAmount();
  }

  closeEditCashCreditArrangementsPopup() {
    $('#edit-cash-credit-arrangements-popup').slideUp();
    $('#cashCreditArrangements').parent().removeClass('editMode');
    this.financialDataForm.controls.cashCreditArrangements.setValue(this.financialDataDisplay.temporaryLoan.cashCreditArrangements);
    this.financialDataForm.controls.dateOfUpdateOfCashCreditArrangements.setValue(this.financialDataDisplay.temporaryLoan.cashCreditArrangementsEffectiveDate);
    this.financialDataForm.controls.remarksOfCashCreditArrangements.setValue(this.financialDataDisplay.temporaryLoan.cashCreditArrangementsRemarks);
  }

  showCashCreditArrangementsHistoryPopup() {
    $("#history-cash-credit-arrangements-popup").modal('show');
  }

  //Discounting of Bills
  showEditDiscountingOfBillsPopup() {
    this.closeAllFieldEditPopup();
    $('#discountingofBills').parent().addClass('editMode');
    var width = $('#discountingofBills').parent().outerWidth();
    $('#edit-discounting-of-bills-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateDiscountingOfBillsValue() {
    $('#edit-discounting-of-bills-popup').slideUp();
    this.financialDataDisplay.temporaryLoan.discountingofBiills = this.financialDataForm.controls.discountingofBiills.value;
    this.financialDataDisplay.temporaryLoan.discountingofBiillsEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfDiscountingofBills.value;
    this.financialDataDisplay.temporaryLoan.discountingofBiillsRemarks = this.financialDataForm.controls.remarksOfDiscountingofBills.value;
    this.temporaryLoansAmount();
  }

  closeEditDiscountingOfBillsPopup() {
    $('#edit-discounting-of-bills-popup').slideUp();
    $('#discountingofBills').parent().removeClass('editMode');
    this.financialDataForm.controls.discountingofBiills.setValue(this.financialDataDisplay.temporaryLoan.discountingofBiills);
    this.financialDataForm.controls.dateOfUpdateOfDiscountingofBills.setValue(this.financialDataDisplay.temporaryLoan.discountingofBiillsEffectiveDate);
    this.financialDataForm.controls.remarksOfDiscountingofBills.setValue(this.financialDataDisplay.temporaryLoan.discountingofBiillsRemarks);
  }

  showDiscountingOfBillsHistoryPopup() {
    $("#history-discounting-of-bills-popup").modal('show');
  }

  //Other Short Term Loans of Seasonal Character
  showEditOtherShortTermLoansofSeasonalCharacterPopup() {
    this.closeAllFieldEditPopup();
    $('#otherShortTermLoansofSeasonalCharacter').parent().addClass('editMode');
    var width = $('#otherShortTermLoansofSeasonalCharacter').parent().outerWidth();
    $('#edit-others-short-term-laon-of-sessinal-character-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateOtherShortTermLoansofSeasonalCharacterValue() {
    $('#edit-others-short-term-laon-of-sessinal-character-popup').slideUp();
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacter = this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.value;
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter.value;
    this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterRemarks = this.financialDataForm.controls.remarksOfOtherShortTermLoansofSeasonalCharacter.value;
    this.temporaryLoansAmount();
  }

  closeEditOtherShortTermLoansofSeasonalCharacterPopup() {
    $('#edit-others-short-term-laon-of-sessinal-character-popup').slideUp();
    $('#otherShortTermLoansofSeasonalCharacter').parent().removeClass('editMode');
    this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.setValue(this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacter);
    this.financialDataForm.controls.dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter.setValue(this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterEffectiveDate);
    this.financialDataForm.controls.remarksOfOtherShortTermLoansofSeasonalCharacter.setValue(this.financialDataDisplay.temporaryLoan.otherShortTermLoansofSeasonalCharacterRemarks);
  }

  showOtherShortTermLoansofSeasonalCharacterHistoryPopup() {
    $("#history-others-short-term-laon-of-sessinal-character-popup").modal('show');
  }

  //Other Outstanding Loans
  showEditOutstandingLoansPopup() {
    this.closeAllFieldEditPopup();
    $('#outstandingLoans').parent().addClass('editMode');
    var width = $('#outstandingLoans').parent().outerWidth();
    $('#edit-others-outstanding-loan-popup').width(width - this.adjustEditHistoryBoxWidth).slideToggle();
  }

  updateOutstandingLoansValue() {
    $('#edit-others-outstanding-loan-popup').slideUp();
    this.financialDataDisplay.temporaryLoan.outstandingLoans = this.financialDataForm.controls.outstandingLoans.value;
    this.financialDataDisplay.temporaryLoan.outstandingLoansEffectiveDate = this.financialDataForm.controls.dateOfUpdateOfOutstandingLoans.value;
    this.financialDataDisplay.temporaryLoan.outstandingLoansRemarks = this.financialDataForm.controls.remarksOfOutstandingLoans.value;
    this.temporaryLoansAmount();
  }

  closeEditOutstandingLoansPopup() {
    $('#edit-others-outstanding-loan-popup').slideUp();
    $('#outstandingLoans').parent().removeClass('editMode');
    this.financialDataForm.controls.outstandingLoans.setValue(this.financialDataDisplay.temporaryLoan.outstandingLoans);
    this.financialDataForm.controls.dateOfUpdateOfOutstandingLoans.setValue(this.financialDataDisplay.temporaryLoan.outstandingLoansEffectiveDate);
    this.financialDataForm.controls.remarksOfOutstandingLoans.setValue(this.financialDataDisplay.temporaryLoan.outstandingLoansRemarks);
  }

  showOutstandingLoansHistoryPopup() {
    $("#history-others-outstanding-loan-popup").modal('show');
  }

  //Total Temporary Loans
  showTotalTemporaryLoansHistoryPopup() {
    $("#history-total-temporary-loan-popup").modal('show');
  }

  //Borrowing (Limits u/s 180)
  showBorrowingLimitHistoryPopup() {
    $("#history-borrowing-limit-popup").modal('show');
  }


  closeAllFieldEditPopup() {
    this.closeEditAditAuthorizedEquitShareCapitalPopup();
    this.closeEditIssuedEquityShareCapitalPopup();
    this.closeEditSubscribedEquityShareCapitalPopup();
    this.closeEditPaidupEquityShareCapitalPopup();
    this.closeEditAuthorizedPreferenceShareCapitalPopup();
    this.closeEditIssuedPreferenceShareCapitalPopup();
    this.closeEditSubscribedPreferenceShareCapitalPopup();
    this.closeEditPaidupPreferenceShareCapitalPopup();
    this.closeEditGeneralReservePopup();
    this.closeEditSurplusPopup();
    this.closeEditDebitBalancePopup();
    this.closeEditOthersPopup();
    this.closeEditCapitalReserveInCashPopup();
    this.closeEditCapitalReserveNotCashPopup();
    this.closeEditCapitalRedemptionReservePopup();
    this.closeEditSecurityPremiumReservePopup();
    this.closeEditOthersCapitalReservePopup();
    this.closeEditTurnoverPopup();
    this.closeEditNetProfitManagerialRemunerationPopup();
    this.closeEditCSRApplicabilityNetProfitPopup();
    this.closeEditLoansGivenPopup();
    this.closeEditGuaranteePopup();
    this.closeEditAcquisitionofsecuritiesPopup();
    this.closeEditLoansOthersAmountPopup();
    this.closeEditLoansfromBankPopup();
    this.closeEditDeferredPaymentLiabilitiesPopup();
    this.closeEditDepositsLongTermAndShortTermPopup();
    this.closeEditLoansandAdvancesfromRelatedPartiesPopup();
    this.closeEditLongTermMaturitiesOfLeaseObligationsPopup();
    this.closeEditBondsAndDebenturesPopup();
    this.closeEditOthersBorrowingPopup();
    this.closeEditShortTermLoansPopup();
    this.closeEditCashCreditArrangementsPopup();
    this.closeEditDiscountingOfBillsPopup();
    this.closeEditOtherShortTermLoansofSeasonalCharacterPopup();
    this.closeEditOutstandingLoansPopup();
  }

  tabShareCapitalClickEvent() {
    this.closeAllFieldEditPopup();
  }

  tabReservesAndSurplusClickEvent() {
    this.closeAllFieldEditPopup();
  }

  tabLoansAndInvestmentsClickEvent() {
    this.closeAllFieldEditPopup();
  }

  tabBorrowingsClickEvent() {
    this.closeAllFieldEditPopup();
  }

  tabTemporaryLoansClickEvent() {
    this.closeAllFieldEditPopup();
  }

  setDate(date) {

    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  messagePopUpTimeoutToogle() {
    setTimeout(function () {
      var popUpClass = $('#messagePopUp').attr('class');
      if (popUpClass == "modal fade show") {
        $('#messagePopUp').modal('toggle');
      }
    }, 3000);
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
      //.toLocaleDateString();
    }
    return null;
  }

  back() {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['company', 'financeDetails']  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/company/financeDetails']);
    this.financialDataForm.reset();
  }

  financialYearValidation() {
    let projectKey = $("#projectKey").val();
    this.projectKeys = projectKey;

  }

  reserveAndSerlusTotalFreeReserves() {

    //  
    let generalReserve = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.generalReserve.value) || 0;
    let surplusProfitAndLoss = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.surplusProfitAndLoss.value) || 0;
    let debitBalanceofStatementofProfitandLoss = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.value) || 0;
    let surplusOthers = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.surplusOthers.value) || 0;

    let totalFreeReserve = generalReserve + surplusProfitAndLoss - debitBalanceofStatementofProfitandLoss + surplusOthers;
    this.financialDataForm.controls.totalFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalFreeReserve)));

    //  
    let capitalReserveProceedsReceivedInCash = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.capitalReserveProceedsReceivedInCash.value) || 0;
    let capitalReserveProceedsNotReceivedInCash = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.capitalReserveProceedsNotReceivedInCash.value) || 0;
    let capitalRedemptionReserve = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.capitalRedemptionReserve.value) || 0;
    let securityPremiumReserve = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.securityPremiumReserve.value) || 0;
    let othersCapitalReserve = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.othersCapitalReserve.value) || 0;

    let totalReservesOtherThanFreeReserves = capitalReserveProceedsReceivedInCash + capitalReserveProceedsNotReceivedInCash + capitalRedemptionReserve + securityPremiumReserve + othersCapitalReserve
    this.financialDataForm.controls.totalReservesOtherThanFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalReservesOtherThanFreeReserves)));

    //
    let totalReservesAndSurplus = totalFreeReserve + totalReservesOtherThanFreeReserves;
    this.financialDataForm.controls.totalReservesAndSurplus.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalReservesAndSurplus)));

    //  
    let totalPaidUpShareCapitalValue = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.totalPaidUpShareCapital.value);

    let shareCapitalAndFreeReserves = totalPaidUpShareCapitalValue + totalFreeReserve;
    this.financialDataForm.controls.shareCapitalAndFreeReserves.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(shareCapitalAndFreeReserves)));

    //
    let netWorth = totalPaidUpShareCapitalValue + totalReservesAndSurplus;
    this.financialDataForm.controls.netWorth.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(netWorth)));
  }

  borrowingAmount() {

    let loansfromBankandFinancialInstitutions = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.loansfromBankandFinancialInstitutions.value) || 0;
    let deferredPaymentLiabilities = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.deferredPaymentLiabilities.value) || 0;
    let depositsLongTermAndShortTerm = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.depositsLongTermAndShortTerm.value) || 0;
    let loansandAdvancesfromRelatedParties = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.loansandAdvancesfromRelatedParties.value) || 0;
    let longTermMaturitiesofLeaseObligations = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.value) || 0;
    let bondsAndDebentures = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.bondsAndDebentures.value) || 0;
    let othersBorrowing = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.othersBorrowing.value) || 0;

    let totalBorrowing = loansfromBankandFinancialInstitutions + deferredPaymentLiabilities + depositsLongTermAndShortTerm +
      loansandAdvancesfromRelatedParties + longTermMaturitiesofLeaseObligations + bondsAndDebentures + othersBorrowing;

    this.financialDataForm.controls.totalBorrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalBorrowing)));

    //
    let totalTemporaryLoans = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.totalTemporaryLoans.value) || 0;
    let borrowingLimitsUS180 = totalBorrowing - totalTemporaryLoans;
    this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(borrowingLimitsUS180)));
  }

  temporaryLoansAmount() {


    let totalBorrowing = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.totalBorrowing.value) || 0;

    let shortTermLoans = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.shortTermLoans.value) || 0;
    let cashCreditArrangements = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.cashCreditArrangements.value) || 0;
    let discountingofBiills = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.discountingofBiills.value) || 0;
    let otherShortTermLoansofSeasonalCharacter = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.value) || 0;
    let outstandingLoans = this.convertCommaSeparatedToNumber(this.financialDataForm.controls.outstandingLoans.value) || 0;

    let totalTemporaryLoans = shortTermLoans + cashCreditArrangements + discountingofBiills + otherShortTermLoansofSeasonalCharacter + outstandingLoans;
    this.financialDataForm.controls.totalTemporaryLoans.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalTemporaryLoans)));

    let borrowingLimitsUS180 = totalBorrowing - totalTemporaryLoans;
    this.financialDataForm.controls.borrowing.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(borrowingLimitsUS180)));
  }

  calculateRoundedTwoDecimal(theform) {
    let decimalOnlyTwoNumber = theform.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    return decimalOnlyTwoNumber;
  }

  numberWithCommas(numberWithcomma) {
    let variable = numberWithcomma.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return variable;
  }

  loanAndInvestMent() {

    var loansOthersAmount = $("#loansOthersAmountInputValue").val();
    var acquisitionAmount = $("#acquisitionAmountInputValue").val();
    var guaranteeAmount = $("#guaranteeAmountInputValue").val();
    var loanGiven = $("#loanGivenInputValue").val();

    if (loansOthersAmount == "") { loansOthersAmount = 0; };
    if (acquisitionAmount == "") { acquisitionAmount = 0; }
    if (guaranteeAmount == "") { guaranteeAmount = 0; }
    if (loanGiven == "") { loanGiven = 0; }

    let totalAmount = this.convertCommaSeparatedToNumber(loansOthersAmount) + this.convertCommaSeparatedToNumber(acquisitionAmount) +
      this.convertCommaSeparatedToNumber(guaranteeAmount) + this.convertCommaSeparatedToNumber(loanGiven);
    $("#totalLoansandInvestmentInputValue").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)))
    this.financialDataForm.controls.totalLoansAndInvestmentsLimits.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)));
  }


  paidCalculationAmount() {
    let paidupEquity = $("#paidupEquitys").val();
    let paidupPreference = $("#paidupPreferences").val();
    if (paidupEquity == "") { paidupEquity = 0; };
    if (paidupPreference == "") { paidupPreference = 0; }
    let totalAmount = this.convertCommaSeparatedToNumber(paidupEquity) + this.convertCommaSeparatedToNumber(paidupPreference);
    $("#totalpaidcalculation").val(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)))
    this.financialDataForm.controls.totalPaidUpShareCapital.setValue(this.commonFunction.formatToCommaSeperatedNumber(this.calculateRoundedTwoDecimal(totalAmount)));

  }

  convertCommaSeparatedToNumber(number) {
    let convertNumber = number.toString().replace(/\,/g, '');
    if (convertNumber != '') {
      let convertedNumber = parseFloat(convertNumber);
      return convertedNumber;
    } else {
      return 0;
    }
  }

  selectPickerChange() {


    this.getFinanceBySelectedYear();

    // this.currentURL = window.location.href;


    // if (this.currentURL.indexOf("add") !== -1) {
    //   this.addNewFinancialDetails();
    //   this.btnValue = 'Save';
    // } else {
    //   this.getFinanceBySelectedYear();
    //   this.btnValue = 'Update';
    // }
  }


  financialData() {
    this.disabledOnclick = true;
    var loginUsers = JSON.parse(localStorage.getItem('companyDetails'));

    var addFinancialData = {
      CompanyID: loginUsers.companyID,
      FinancialYear: this.financialDataForm.controls.FinancialYear.value,
      AuthorizedEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedEquityShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateAuthorizedEquityShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksAuthorizedEquityShareCapital.value
      },
      IssuedEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedEquityShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfIssuedEquityShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfIssuedEquityShareCapital.value
      },
      SubscribedShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedEquityShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfsubscribedShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfsubscribedShareCapital.value
      },
      PaidupEquityShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupEquityShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfPaidupEquityShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfPaidupEquityShareCapital.value
      },
      AuthorizedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedPreferenceShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfAuthorizedPreferenceShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfAuthorizedPreferenceShareCapital.value
      },
      IssuedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedPreferenceShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfIssuedPreferenceShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfIssuedPreferenceShareCapital.value
      },
      SubscribedPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedPreferenceShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfSubscribedPreferenceShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfSubscribedPreferenceShareCapital.value
      },
      PaidupPreferenceShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupPreferenceShareCapital.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfPaidupPreferenceShareCapital.value),
        Remarks: this.financialDataForm.controls.remarksOfPaidupPreferenceShareCapital.value
      },
      TotalPaidUpShareCapital: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalPaidUpShareCapital.value),
        EffectiveDate: null,
        Remarks: null
      },
      GeneralReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.generalReserve.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfGeneralReserve.value),
        Remarks: this.financialDataForm.controls.remarksOfGeneralReserve.value
      },
      Surplus: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.surplusProfitAndLoss.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfSurplus.value),
        Remarks: this.financialDataForm.controls.remarksOfSurplus.value
      },
      DebitBalanceofStatementofProfitandLoss: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.debitBalanceofStatementofProfitandLoss.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfDebitBalanceofStatementofProfitandLoss.value),
        Remarks: this.financialDataForm.controls.remarksOfDebitBalanceofStatementofProfitandLoss.value
      },
      SurplusOthers: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.surplusOthers.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfSurplusOthers.value),
        Remarks: this.financialDataForm.controls.remarksOfSurplusOthers.value
      },
      TotalFreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalFreeReserves.value),
        EffectiveDate: null,
        Remarks: null
      },
      CapitalReserveCash: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.capitalReserveProceedsReceivedInCash.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfCapitalReserveInCash.value),
        Remarks: this.financialDataForm.controls.remarksOfCapitalReserveInCash.value
      },
      CapitalReserveNotCash: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.capitalReserveProceedsNotReceivedInCash.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfCapitalReserveNotCash.value),
        Remarks: this.financialDataForm.controls.remarksOfCapitalReserveNotCash.value
      },
      CapitalRedemptionReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.capitalRedemptionReserve.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfCapitalRedemptionReserve.value),
        Remarks: this.financialDataForm.controls.remarksOfCapitalRedemptionReserve.value
      },
      SecurityPremiumReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.securityPremiumReserve.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfSecurityPremiumReserve.value),
        Remarks: this.financialDataForm.controls.remarksOfSecurityPremiumReserve.value
      },
      OthersCapitalReserve: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.othersCapitalReserve.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfOthersCapitalReserve.value),
        Remarks: this.financialDataForm.controls.remarksOfOthersCapitalReserve.value
      },
      NetWorth: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.netWorth.value),
        EffectiveDate: null,
        Remarks: null
      },
      Turnover: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.turnover.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfTurnover.value),
        Remarks: this.financialDataForm.controls.remarksOfTurnover.value
      },
      ManagerialRemunerationNetProfit: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.netProfitForManagerialRemuneration.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfManagerialRemunerationNetProfit.value),
        Remarks: this.financialDataForm.controls.remarksOfManagerialRemunerationNetProfit.value
      },
      CSRApplicabilityNetProfit: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.netProfitForCSRApplicability.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfCSRApplicabilityNetProfit.value),
        Remarks: this.financialDataForm.controls.remarksOfCSRApplicabilityNetProfit.value
      },
      LoanGiven: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loanGiven.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfLoanGiven.value),
        Remarks: this.financialDataForm.controls.remarksOfLoanGiven.value
      },
      SecurityofLoan: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.guaranteeOrSecurityGiven.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfSecurityofLoan.value),
        Remarks: this.financialDataForm.controls.remarksOfSecurityofLoan.value
      },
      AcquisitionCost: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.acquisitionOfSecurities.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfAcquisitionCost.value),
        Remarks: this.financialDataForm.controls.remarksOfAcquisitionCost.value
      },
      LoansOthers: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansOthers.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfLoansOthers.value),
        Remarks: this.financialDataForm.controls.remarksOfLoansOthers.value
      },
      TotalLoansAndInvestmentsLimits: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalLoansAndInvestmentsLimits.value),
        EffectiveDate: null,
        Remarks: null
      },
      LoansfromBankandFinancialInstitutions: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansfromBankandFinancialInstitutions.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfLoansfromBankandFinancialInstitutions.value),
        Remarks: this.financialDataForm.controls.remarksOfLoansfromBankandFinancialInstitutions.value
      },
      DeferredPaymentLiabilities: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.deferredPaymentLiabilities.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfDeferredPaymentLiabilities.value),
        Remarks: this.financialDataForm.controls.remarksOfDeferredPaymentLiabilities.value
      },
      Deposits: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.depositsLongTermAndShortTerm.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfDeposits.value),
        Remarks: this.financialDataForm.controls.remarksOfDeposits.value
      },
      LoansandAdvancesfromRelatedParties: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.loansandAdvancesfromRelatedParties.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfLoansandAdvancesfromRelatedParties.value),
        Remarks: this.financialDataForm.controls.remarksOfLoansandAdvancesfromRelatedParties.value
      },
      LongTermMaturitiesofLeaseObligations: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.longTermMaturitiesofLeaseObligations.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfLongTermMaturitiesofLeaseObligations.value),
        Remarks: this.financialDataForm.controls.remarksOfLongTermMaturitiesofLeaseObligations.value
      },
      BondsDebentures: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.bondsAndDebentures.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfBondsDebentures.value),
        Remarks: this.financialDataForm.controls.remarksOfBondsDebentures.value
      },
      OthersBorrowing: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.othersBorrowing.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfOthersBorrowing.value),
        Remarks: this.financialDataForm.controls.remarksOfOthersBorrowing.value
      },
      ShortTermLoans: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.shortTermLoans.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfShortTermLoans.value),
        Remarks: this.financialDataForm.controls.remarksOfShortTermLoans.value
      },
      CashCreditArrangements: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.cashCreditArrangements.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfCashCreditArrangements.value),
        Remarks: this.financialDataForm.controls.remarksOfCashCreditArrangements.value
      },
      DiscountingofBills: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.discountingofBiills.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfDiscountingofBills.value),
        Remarks: this.financialDataForm.controls.remarksOfDiscountingofBills.value
      },
      OtherShortTermLoansofSeasonalCharacter: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.otherShortTermLoansofSeasonalCharacter.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter.value),
        Remarks: this.financialDataForm.controls.remarksOfOtherShortTermLoansofSeasonalCharacter.value
      },
      OutstandingLoans: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.outstandingLoans.value),
        EffectiveDate: this.setDate(this.financialDataForm.controls.dateOfUpdateOfOutstandingLoans.value),
        Remarks: this.financialDataForm.controls.remarksOfOutstandingLoans.value
      },
      OtherthanfreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalReservesOtherThanFreeReserves.value),
        EffectiveDate: null,
        Remarks: null
      },
      TotalReservesandSurplus: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalReservesAndSurplus.value),
        EffectiveDate: null,
        Remarks: null
      },
      ShareCapitalandFreeReserves: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.shareCapitalAndFreeReserves.value),
        EffectiveDate: null,
        Remarks: null
      },
      BorrowingLimitsUS180: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.borrowing.value),
        EffectiveDate: null,
        Remarks: null
      },
      TotalBorrowingAmount: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalBorrowing.value),
        EffectiveDate: null,
        Remarks: null
      },
      TotalTemporaryLoansAmount: {
        value: this.commaSeperatedToNumberOnly(this.financialDataForm.controls.totalTemporaryLoans.value),
        EffectiveDate: null,
        Remarks: null
      }
    }
    this.companyMasterService.financialData(addFinancialData)
      .subscribe(addFinancialData => {
        this.disabledOnclick = false;
        if (addFinancialData.status == 0) {
          $(".historyTable").DataTable().destroy();
          this.alert.success(addFinancialData.message);
          this.financialDataDetails = addFinancialData.data;
          this.bindFinancialDataToUI();
        } else {
          this.alert.error(addFinancialData.message);
        }
      });
  }

  /**
   * check validation on share capital tab
   */
  checkfinanceValidation() {

    var AuthorizedShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedEquityShareCapital.value);
    var IssuedEquityShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedEquityShareCapital.value);
    var SubscribedShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedEquityShareCapital.value);
    var PaidupEquityShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupEquityShareCapital.value);
    var AuthorizedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.authorizedPreferenceShareCapital.value);
    var IssuedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.issuedPreferenceShareCapital.value);
    var SubscribedPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.subscribedPreferenceShareCapital.value);
    var PaidupPreferenceShareCapital = this.commaSeperatedToNumberOnly(this.financialDataForm.controls.paidupPreferenceShareCapital.value);


    // check validation for AuthorizedShareCapital
    if (AuthorizedShareCapital != "" || AuthorizedShareCapital !== null) {
      if (parseFloat(AuthorizedShareCapital) < parseFloat(IssuedEquityShareCapital)) {
        this.checkValidationInput = true;
        this.IssuedEquityError = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(AuthorizedShareCapital) < parseFloat(SubscribedShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(AuthorizedShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.IssuedEquityError = {
          isError: false
        };
        this.SubscribedShareCapital = {
          isError: false
        };
        this.PaidupEquityShareCapital = {
          isError: false
        };

      }
    }

    // check validation for IssuedEquityShareCapital
    if (IssuedEquityShareCapital != "" || IssuedEquityShareCapital !== null) {
      if (parseFloat(IssuedEquityShareCapital) < parseFloat(SubscribedShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Equity Share Capital.'
        };
        return false;
      }
      else if (parseFloat(IssuedEquityShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.SubscribedShareCapital = {
          isError: false
        };
        this.PaidupEquityShareCapital = {
          isError: false
        };
      }
    }

    // check validation for SubscribedShareCapital
    if (SubscribedShareCapital != "" || SubscribedShareCapital !== null) {
      if (parseFloat(SubscribedShareCapital) < parseFloat(PaidupEquityShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupEquityShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Subscribed Equity Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.PaidupEquityShareCapital = {
          isError: false
        };

      }
    }

    // check validation for AuthorizedPreferenceShareCapital
    if (AuthorizedPreferenceShareCapital != "" || AuthorizedPreferenceShareCapital !== null) {
      if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(IssuedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.IssuedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(SubscribedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else if ((parseFloat(AuthorizedPreferenceShareCapital)) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Authorized Preference Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.IssuedPreferenceShareCapital = {
          isError: false
        };
        this.SubscribedPreferenceShareCapital = {
          isError: false
        };
        this.PaidupPreferenceShareCapital = {
          isError: false
        };
      }
    }

    // check validation for IssuedPreferenceShareCapital
    if (IssuedPreferenceShareCapital != "" || IssuedPreferenceShareCapital !== null) {
      if (parseFloat(IssuedPreferenceShareCapital) < parseFloat(SubscribedPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.SubscribedPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Preference Share Capital.'
        };
        return false;
      } else if (parseFloat(IssuedPreferenceShareCapital) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Issued Preference Share Capital.'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.SubscribedPreferenceShareCapital = {
          isError: false
        };
        this.PaidupPreferenceShareCapital = {
          isError: false
        };
      }
    }

    // check validation for IssuedPreferenceShareCapital
    if (SubscribedPreferenceShareCapital != "" || IssuedPreferenceShareCapital !== null) {
      if (parseFloat(SubscribedPreferenceShareCapital) < parseFloat(PaidupPreferenceShareCapital)) {
        this.checkValidationInput = true;
        this.PaidupPreferenceShareCapital = {
          isError: true, errorMessage: 'Should not be greater than Subscribed Preference Share Capital'
        };
        return false;
      } else {
        this.checkValidationInput = false;
        this.PaidupPreferenceShareCapital = {
          isError: false
        };

      }
    }
    else
      this.error = { isError: false, errorMessage: '' }

    return true;
  }

  compareTwoDates() {

    if (this.financialYearToModel == null && this.financialYearFromModel == null) {
      this.error = { isError: false, errorMessage: '' }
      return true;
    }

    if (this.financialYearToModel == null || this.financialYearFromModel == null) {
      this.error = {
        isError: true, errorMessage: 'Both date is required.'
      };
      return false;
    }

    if (new Date(this.setDate(this.financialYearToModel)) < new Date(this.setDate(this.financialYearFromModel))) {
      this.error = {
        isError: true, errorMessage: 'Financial year To date cannot be set before Financial year From date.'
      };
      return false;
    }
    else
      this.error = { isError: false, errorMessage: '' }

    return true;
  }

  onlyTwoDecimal(ev) {
    $('.dacimalFix').on('input', function () {
      this.value = this.value.replace(/(\.[\d]{2})./g, '$1'); // not more than 2 digits after decimal
    });
  }

  //--DELETE selected category for assessment
  deleteConfirmation(companyId) {
    this.companyId = companyId
    $('#confirmation').modal('toggle');
  }

  validatepaidUp() {
    return false;
  }

  setCompnayDetails() {
    var loginUsers = JSON.parse(localStorage.getItem('companyDetails'));

    this.companyID = loginUsers.companyID;
    this.companyName = loginUsers.companyName;
    console.log(this.companyName)
  }

  //get the peers list of selected company and binds to the peer list. 
  getPeersListOnCompanySelected(item: any) {
    this.bindPeersofSelectedCompany(item.value);
  }

  //bind peers of selected company
  bindPeersofSelectedCompany(itemValue) {

    //get industry and housing code by selected company
    this.companyMasterService.getSelectedCompanyDetailsFromFinCode(itemValue).subscribe((selectedCompany:any) => {
      if (selectedCompany.status == 0) {
        this.industryCode = selectedCompany.selectedCompanyDetails.IndustryCode;
        this.housingCode = selectedCompany.selectedCompanyDetails.HousingCode;
        //get industry And Housing Wise Peers from industry and housing code
        this.companyMasterService.getindustryAndHousingWisePeers(this.industryCode, this.housingCode)
          .subscribe((peers:any) => {
            if (peers.status == 0 && peers.IndustryAndHousingPeers.length > 0) {

              this.peersList = peers.IndustryAndHousingPeers.map(function (o) {
                return {
                  'label': o.COMPNAME,
                  'value': o.FINCODE
                }
              });
            }

            if (this.peersList.length > 0) {
              let indexOfItem = this.peersList.findIndex(o => o.value === itemValue);
              if (indexOfItem > -1)
                //reomve the peers name (if peers is then same company name which is is selected ) from the collection 
                this.peersList.splice(indexOfItem, 1);
            }
          });
      }
    });
  }

  //bind selected peers id and name to the list
  getSelectedPeers(item: any) {
    // this.selectedPeers.push([item.label, item.value]);
    this.selectedPeers.push(item);
    //invalidPeers
    if (this.selectedPeers.length <= 5)
      this.invalidPeers = false;
    else
      this.invalidPeers = true;
  }

  //remove peers from list which is removed from ng-select control
  multiplePeersDeselected(item: any) {

    let indexOfItem = this.selectedPeers.findIndex(o => o.value === item.value);
    this.selectedPeers.splice(indexOfItem, 1);

    if (this.selectedPeers.length <= 5)
      this.invalidPeers = false;
    else
      this.invalidPeers = true;
  }

  //Loans And INvestments
  loansGivenModel: any = 0;
  Guarantee: any = 0;
  Acquisition: any = 0;
  Others: any = 0;
  TotalLoansInvestment: any = 0;

  getTotalLoansAndInvestment() {

    if (this.loansGivenModel == undefined) { this.loansGivenModel == 0 }
    if (this.Guarantee == undefined) { this.Guarantee == 0 }
    if (this.Acquisition == undefined) { this.Acquisition == 0 }
    if (this.Others == undefined) { this.Others == 0 }
    if (this.TotalLoansInvestment == undefined) { this.TotalLoansInvestment == 0 }

    this.TotalLoansInvestment = parseFloat(this.loansGivenModel) + parseFloat(this.Guarantee) + parseFloat(this.Acquisition) + parseFloat(this.Others)
  }

  //Borrowng Tab Calculations
  getBorrowning() {
    this.TotalBorrowingAggregate = parseFloat(this.LoansfromBank) + parseFloat(this.DeferredPayment) + parseFloat(this.Depositsaccepted) + parseFloat(this.LoansandAdvances) + parseFloat(this.LongTermMaturities) + parseFloat(this.BondsDebentures)
  }

  commaSeperatedToNumberOnly(value) {
    if (value == "" || value == null || value == undefined) {
      return "";
    }
    else {
      value = value.toString();
      return value.replace(new RegExp(",".replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'g'), "");
    }
  }

  // Export to Excel functionality
  exportToExcel() {
    try {
      const workbook = XLSX.utils.book_new();
      
      // Prepare data for each tab
      const tabs = [
        { name: 'Share Capital', data: this.getShareCapitalData() },
        { name: 'Reserves and Surplus', data: this.getReservesAndSurplusData() },
        { name: 'Loans and Investments', data: this.getLoansAndInvestmentsData() },
        { name: 'Borrowings', data: this.getBorrowingsData() },
        { name: 'Temporary Loans', data: this.getTemporaryLoansData() }
      ];

      tabs.forEach(tab => {
        if (tab.data && tab.data.length > 0) {
          const worksheet = XLSX.utils.aoa_to_sheet(tab.data);
          XLSX.utils.book_append_sheet(workbook, worksheet, tab.name);
        }
      });

      // Generate filename with company name and financial year
      const filename = `Financial_Data_${this.companyNameModel || 'Company'}_${this.newfinanceyear || 'FY'}_${new Date().toISOString().split('T')[0]}.xlsx`;
      
      // Export the file
      XLSX.writeFile(workbook, filename);
      
      // Show success message
      alert('Financial data exported to Excel successfully!');
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      alert('Error exporting to Excel. Please try again.');
    }
  }

  // Export to PDF functionality
  exportToPDF() {
    try {
      const doc = new jsPDF();
      let yPosition = 20;
      
      // Add title with proper spacing
      doc.setFontSize(16);
      doc.text(`Financial Data Update - ${this.newfinanceyear || 'FY'}`, 14, yPosition);
      yPosition += 20; // Increased spacing after title
      
      doc.setFontSize(12);
      doc.text(`Company: ${this.companyNameModel || 'N/A'}`, 14, yPosition);
      yPosition += 15; // Increased spacing after company
      
      doc.text(`Export Date: ${new Date().toLocaleDateString()}`, 14, yPosition);
      yPosition += 25; // Increased spacing before table

      // Add each tab as a separate page
      const tabs = [
        { name: 'Share Capital', data: this.getShareCapitalData() },
        { name: 'Reserves and Surplus', data: this.getReservesAndSurplusData() },
        { name: 'Loans and Investments', data: this.getLoansAndInvestmentsData() },
        { name: 'Borrowings', data: this.getBorrowingsData() },
        { name: 'Temporary Loans', data: this.getTemporaryLoansData() }
      ];

      tabs.forEach((tab, index) => {
        if (index > 0) {
          doc.addPage();
          yPosition = 20; // Reset position for new page
        }
        
        // Add tab title with proper spacing
        doc.setFontSize(14);
        doc.text(tab.name, 14, yPosition);
        yPosition += 20; // Increased spacing after tab title
        
        if (tab.data && tab.data.length > 0) {
          // Auto table for data with proper start position
          (doc as any).autoTable({
            startY: yPosition,
            head: [tab.data[0]], // First row as header
            body: tab.data.slice(1), // Rest as body
            theme: 'grid',
            styles: { fontSize: 8 },
            headStyles: { fillColor: [89, 140, 137] }, // Teal color matching your theme
            margin: { top: 10, right: 14, bottom: 10, left: 14 } // Add margins for better spacing
          });
        } else {
          doc.setFontSize(10);
          doc.text('No data available', 14, yPosition + 10);
        }
      });

      // Generate filename and save
      const filename = `Financial_Data_${this.companyNameModel || 'Company'}_${this.newfinanceyear || 'FY'}_${new Date().toISOString().split('T')[0]}.pdf`;
      doc.save(filename);
      
      // Show success message
      alert('Financial data exported to PDF successfully!');
    } catch (error) {
      console.error('Error exporting to PDF:', error);
      alert('Error exporting to PDF. Please try again.');
    }
  }

  // Helper methods to get data for each tab
  getShareCapitalData(): any[][] {
    const data = [
      ['Field', 'Value', 'Effective Date', 'Remarks'],
      ['Financial Year', this.financialDataForm.get('FinancialYear')?.value || '', '', ''],
      ['', '', '', ''], // Separator
      // Left Column - Equity Share Capital
      ['Authorized Equity Share Capital', this.formatNumber(this.financialDataForm.get('authorizedEquityShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateAuthorizedEquityShareCapital')?.value), this.financialDataForm.get('remarksAuthorizedEquityShareCapital')?.value || ''],
      ['Issued Equity Share Capital', this.formatNumber(this.financialDataForm.get('issuedEquityShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfIssuedEquityShareCapital')?.value), this.financialDataForm.get('remarksOfIssuedEquityShareCapital')?.value || ''],
      ['Subscribed Equity Share Capital', this.formatNumber(this.financialDataForm.get('subscribedEquityShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfsubscribedShareCapital')?.value), this.financialDataForm.get('remarksOfsubscribedShareCapital')?.value || ''],
      ['Paidup Equity Share Capital', this.formatNumber(this.financialDataForm.get('paidupEquityShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfPaidupEquityShareCapital')?.value), this.financialDataForm.get('remarksOfPaidupEquityShareCapital')?.value || ''],
      ['Total Paid up Share Capital', this.formatNumber(this.financialDataForm.get('totalPaidUpShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalPaidUpShareCapital')?.value), this.financialDataForm.get('remarksOfTotalPaidUpShareCapital')?.value || ''],
      ['', '', '', ''], // Separator
      // Right Column - Preference Share Capital
      ['Authorized Preference Share Capital', this.formatNumber(this.financialDataForm.get('authorizedPreferenceShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfAuthorizedPreferenceShareCapital')?.value), this.financialDataForm.get('remarksOfAuthorizedPreferenceShareCapital')?.value || ''],
      ['Issued Preference Share Capital', this.formatNumber(this.financialDataForm.get('issuedPreferenceShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfIssuedPreferenceShareCapital')?.value), this.financialDataForm.get('remarksOfIssuedPreferenceShareCapital')?.value || ''],
      ['Subscribed Preference Share Capital', this.formatNumber(this.financialDataForm.get('subscribedPreferenceShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfSubscribedPreferenceShareCapital')?.value), this.financialDataForm.get('remarksOfSubscribedPreferenceShareCapital')?.value || ''],
      ['Paidup Preference Share Capital', this.formatNumber(this.financialDataForm.get('paidupPreferenceShareCapital')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfPaidupPreferenceShareCapital')?.value), this.financialDataForm.get('remarksOfPaidupPreferenceShareCapital')?.value || '']
    ];
    return data;
  }

  getReservesAndSurplusData(): any[][] {
    const data = [
      ['Field', 'Value', 'Effective Date', 'Remarks'],
      ['', '', '', ''], // Separator
      // Left Column
      ['General Reserve', this.formatNumber(this.financialDataForm.get('generalReserve')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfGeneralReserve')?.value), this.financialDataForm.get('remarksOfGeneralReserve')?.value || ''],
      ['Debit Balance in P & L', this.formatNumber(this.financialDataForm.get('debitBalanceofStatementofProfitandLoss')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfDebitBalanceofStatementofProfitandLoss')?.value), this.financialDataForm.get('remarksOfDebitBalanceofStatementofProfitandLoss')?.value || ''],
      ['Total Free Reserves', this.formatNumber(this.financialDataForm.get('totalFreeReserves')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalFreeReserves')?.value), this.financialDataForm.get('remarksOfTotalFreeReserves')?.value || ''],
      ['Capital Reserve (proceeds not received in cash)', this.formatNumber(this.financialDataForm.get('capitalReserveProceedsNotReceivedInCash')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfCapitalReserveNotCash')?.value), this.financialDataForm.get('remarksOfCapitalReserveNotCash')?.value || ''],
      ['Security Premium Reserve', this.formatNumber(this.financialDataForm.get('securityPremiumReserve')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfSecurityPremiumReserve')?.value), this.financialDataForm.get('remarksOfSecurityPremiumReserve')?.value || ''],
      ['Total Reserves other than Free Reserves', this.formatNumber(this.financialDataForm.get('totalReservesOtherThanFreeReserves')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalReservesOtherThanFreeReserves')?.value), this.financialDataForm.get('remarksOfTotalReservesOtherThanFreeReserves')?.value || ''],
      ['Share Capital and Free Reserves', this.formatNumber(this.financialDataForm.get('shareCapitalAndFreeReserves')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfShareCapitalAndFreeReserves')?.value), this.financialDataForm.get('remarksOfShareCapitalAndFreeReserves')?.value || ''],
      ['Turnover', this.formatNumber(this.financialDataForm.get('turnover')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTurnover')?.value), this.financialDataForm.get('remarksOfTurnover')?.value || ''],
      ['Net Profit (For CSR Applicability)', this.formatNumber(this.financialDataForm.get('netProfitForCSRApplicability')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfCSRApplicabilityNetProfit')?.value), this.financialDataForm.get('remarksOfCSRApplicabilityNetProfit')?.value || ''],
      ['', '', '', ''], // Separator
      // Right Column
      ['Surplus in P & L', this.formatNumber(this.financialDataForm.get('surplusProfitAndLoss')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfSurplus')?.value), this.financialDataForm.get('remarksOfSurplus')?.value || ''],
      ['Others', this.formatNumber(this.financialDataForm.get('others')?.value), '', ''],
      ['Capital Reserve (proceeds received in cash)', this.formatNumber(this.financialDataForm.get('capitalReserveProceedsReceivedInCash')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfCapitalReserveInCash')?.value), this.financialDataForm.get('remarksOfCapitalReserveInCash')?.value || ''],
      ['Capital Redemption Reserve (In excess of Preference shares redeemed)', this.formatNumber(this.financialDataForm.get('capitalRedemptionReserve')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfCapitalRedemptionReserve')?.value), this.financialDataForm.get('remarksOfCapitalRedemptionReserve')?.value || ''],
      ['Others', this.formatNumber(this.financialDataForm.get('OthersCapitalReserve')?.value), '', ''],
      ['Total Reserves and Surplus', this.formatNumber(this.financialDataForm.get('totalReservesAndSurplus')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOftotalReservesAndSurplus')?.value), this.financialDataForm.get('remarksOftotalReservesAndSurplus')?.value || ''],
      ['Net Worth', this.formatNumber(this.financialDataForm.get('netWorth')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfNetWorth')?.value), this.financialDataForm.get('remarksOfNetWorth')?.value || ''],
      ['Net Profit (For managerial remuneration)', this.formatNumber(this.financialDataForm.get('netProfitForManagerialRemuneration')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfManagerialRemunerationNetProfit')?.value), this.financialDataForm.get('remarksOfManagerialRemunerationNetProfit')?.value || '']
    ];
    return data;
  }

  getLoansAndInvestmentsData(): any[][] {
    const data = [
      ['Field', 'Value', 'Effective Date', 'Remarks'],
      ['', '', '', ''], // Separator
      // Left Column
      ['Loans given', this.formatNumber(this.financialDataForm.get('loanGiven')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfLoanGiven')?.value), this.financialDataForm.get('remarksOfLoanGiven')?.value || ''],
      ['Acquisition of securities', this.formatNumber(this.financialDataForm.get('acquisitionOfSecurities')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfAcquisitionCost')?.value), this.financialDataForm.get('remarksOfAcquisitionCost')?.value || ''],
      ['Total Loans and Investments (Limits u/s 186)', this.formatNumber(this.financialDataForm.get('totalLoansAndInvestmentsLimits')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalLoansAndInvestmentsLimits')?.value), this.financialDataForm.get('remarksOfTotalLoansAndInvestmentsLimits')?.value || ''],
      ['', '', '', ''], // Separator
      // Right Column
      ['Guarantee or security given', this.formatNumber(this.financialDataForm.get('guaranteeOrSecurityGiven')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfSecurityofLoan')?.value), this.financialDataForm.get('remarksOfSecurityofLoan')?.value || ''],
      ['Others', this.formatNumber(this.financialDataForm.get('loansOthers')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfLoansOthers')?.value), this.financialDataForm.get('remarksOfLoansOthers')?.value || '']
    ];
    return data;
  }

  getBorrowingsData(): any[][] {
    const data = [
      ['Field', 'Value', 'Effective Date', 'Remarks'],
      ['', '', '', ''], // Separator
      // Left Column
      ['Loans from Bank and Financial Institutions', this.formatNumber(this.financialDataForm.get('loansfromBankandFinancialInstitutions')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfLoansfromBankandFinancialInstitutions')?.value), this.financialDataForm.get('remarksOfLoansfromBankandFinancialInstitutions')?.value || ''],
      ['Deposits (long term and short term)', this.formatNumber(this.financialDataForm.get('depositsLongTermAndShortTerm')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfDeposits')?.value), this.financialDataForm.get('remarksOfDeposits')?.value || ''],
      ['Long Term Maturities of Lease Obligations', this.formatNumber(this.financialDataForm.get('longTermMaturitiesofLeaseObligations')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfLongTermMaturitiesofLeaseObligations')?.value), this.financialDataForm.get('remarksOfLongTermMaturitiesofLeaseObligations')?.value || ''],
      ['Others', this.formatNumber(this.financialDataForm.get('othersBorrowing')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfOthersBorrowing')?.value), this.financialDataForm.get('remarksOfOthersBorrowing')?.value || ''],
      ['', '', '', ''], // Separator
      // Right Column
      ['Deferred Payment Liabilities', this.formatNumber(this.financialDataForm.get('deferredPaymentLiabilities')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfDeferredPaymentLiabilities')?.value), this.financialDataForm.get('remarksOfDeferredPaymentLiabilities')?.value || ''],
      ['Loans and Advances', this.formatNumber(this.financialDataForm.get('loansandAdvancesfromRelatedParties')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfLoansandAdvancesfromRelatedParties')?.value), this.financialDataForm.get('remarksOfLoansandAdvancesfromRelatedParties')?.value || ''],
      ['Bonds and Debentures', this.formatNumber(this.financialDataForm.get('bondsAndDebentures')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfBondsDebentures')?.value), this.financialDataForm.get('remarksOfBondsDebentures')?.value || ''],
      ['Total Borrowing', this.formatNumber(this.financialDataForm.get('totalBorrowing')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalBorrowing')?.value), this.financialDataForm.get('remarksOfTotalBorrowing')?.value || '']
    ];
    return data;
  }

  getTemporaryLoansData(): any[][] {
    const data = [
      ['Field', 'Value', 'Effective Date', 'Remarks'],
      ['', '', '', ''], // Separator
      // Left Column
      ['Short Term Loans', this.formatNumber(this.financialDataForm.get('shortTermLoans')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfShortTermLoans')?.value), this.financialDataForm.get('remarksOfShortTermLoans')?.value || ''],
      ['Discounting of Bills', this.formatNumber(this.financialDataForm.get('discountingofBiills')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfDiscountingofBills')?.value), this.financialDataForm.get('remarksOfDiscountingofBills')?.value || ''],
      ['Others', this.formatNumber(this.financialDataForm.get('outstandingLoans')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfOutstandingLoans')?.value), this.financialDataForm.get('remarksOfOutstandingLoans')?.value || ''],
      ['Borrowing (Limits u/s 180)', this.formatNumber(this.financialDataForm.get('borrowing')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfBorrowing')?.value), this.financialDataForm.get('remarksOfBorrowing')?.value || ''],
      ['', '', '', ''], // Separator
      // Right Column
      ['Cash Credit Arrangements', this.formatNumber(this.financialDataForm.get('cashCreditArrangements')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfCashCreditArrangements')?.value), this.financialDataForm.get('remarksOfCashCreditArrangements')?.value || ''],
      ['Other Short Term Loans of Seasonal Character', this.formatNumber(this.financialDataForm.get('otherShortTermLoansofSeasonalCharacter')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfOtherShortTermLoansofSeasonalCharacter')?.value), this.financialDataForm.get('remarksOfOtherShortTermLoansofSeasonalCharacter')?.value || ''],
      ['Total Temporary Loans', this.formatNumber(this.financialDataForm.get('totalTemporaryLoans')?.value), this.formatDate(this.financialDataForm.get('dateOfUpdateOfTotalTemporaryLoans')?.value), this.financialDataForm.get('remarksOfTotalTemporaryLoans')?.value || '']
    ];
    return data;
  }

  // Helper method to format numbers
  formatNumber(value: any): string {
    if (value === null || value === undefined || value === '') {
      return '0';
    }
    const numValue = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
    return isNaN(numValue) ? '0' : numValue.toLocaleString();
  }

  // Helper method to format dates
  formatDate(dateValue: any): string {
    if (!dateValue || dateValue === null || dateValue === undefined) {
      return '';
    }
    
    // Handle object format { day: X, month: Y, year: Z }
    if (typeof dateValue === 'object' && dateValue.day && dateValue.month && dateValue.year) {
      return `${dateValue.day.toString().padStart(2, '0')}/${dateValue.month.toString().padStart(2, '0')}/${dateValue.year}`;
    }
    
    // Handle string format
    if (typeof dateValue === 'string') {
      try {
        const date = new Date(dateValue);
        if (!isNaN(date.getTime())) {
          return date.toLocaleDateString();
        }
      } catch (e) {
        return dateValue; // Return as-is if can't parse
      }
    }
    
    return dateValue.toString();
  }

}
